import { DatePipe } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit, AfterViewInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AttachmentToUpdate, CustomerSpecialRequirement, Enquiry, EnquiryAttachment, EnquiryAttachmentToDelete, EnquiryHeader, EnquiryHeaderItem, EnquiryNpsSchedule, EnquiyNormGrade, OrderExtraCost } from 'src/app/shared/models/data/enquiry.model';
import { HeaderParametersValues, MarketFamily, SalesOfficePerson, Uom, UomsType } from 'src/app/shared/models/data/headerParametersValues.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { DialogButton, DialogForm, DialogObject, DialogSelect } from 'src/app/shared/teiasoft-bucket/teiasoft-dialog/teiasoft-dialog.component';
import { CustomIcoCol, GridDataset } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { Autocomplete } from 'src/app/shared/teiasoft-bucket/teiasoft-input/teiasoft-input.component';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';
//import * as _ from 'lodash';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { NpsAndSchedule } from 'src/app/shared/models/data/npsAndSchedules.model';
import { Globals } from 'src/app/shared/globals/globals';
import { EditEnquiry } from 'src/app/shared/models/data/editEnquiry.model';
import { TeiasoftToasterService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-toaster.service';
import { TeiasoftModalService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-modal.service';
import { ItemSms } from 'src/app/shared/models/data/itemsByEnquiryNo.model';
import { ItemParametersValues, Mill, TubeExecution } from 'src/app/shared/models/data/itemParametersValues.model';
import { ItemLimitation, ItemToUpdate } from 'src/app/shared/models/data/itemToUpdate.model';
import { CalculatedCols } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { __metadata } from 'tslib';
import { DownloadGridColumn, ItemsFromXlsx } from 'src/app/shared/models/data/itemsFromXlsx.model';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { RawMaterialGrade } from 'src/app/shared/models/data/rawMaterialGrades.model';
import { LimitationsForNormGrades } from 'src/app/shared/models/data/limitationsForNormGrades.model';
import { RoundDigit } from 'src/app/shared/models/data/roundDigit.model';
import { UpdateItemsPriceAndDelivery } from 'src/app/shared/models/data/extraCostParametersValues.model';
import { ItemsPricesFromXlsx } from 'src/app/shared/models/data/itemsPricesFromXlsx.model.';
import { UserConfiguration } from 'src/app/shared/models/data/userConfiguration.model';
import { ItemsFromAI } from 'src/app/shared/models/data/itemsFromIA.model';
import _, { cloneDeep } from 'lodash';
import { ItemParametersLengthValues } from 'src/app/shared/models/data/itemParametersLengthValues.model';
import { RawMaterialGradesService } from 'src/app/shared/services/backend/raw-material-grades.service';
import { Material, Materials } from 'src/app/shared/models/data/materials.model';
import { CalculateMarginsAndPricesPayload, ItemPrice } from 'src/app/shared/models/data/calculateMarginsAndPricesPayload.model';
import { OpenItdcrEvent } from 'src/app/shared/models/app/openItdcr.model';
import { EnquiryTotalPriceAndMargin } from 'src/app/shared/models/data/enquiryTotalPriceAndMargin.model';
import { Router } from '@angular/router';
import { parseGridActionEvent } from 'src/app/shared/utils/grid-event.utils';

declare var $: any;

@Component({
  selector: 'app-edit-enquiry',
  templateUrl: './edit-enquiry.component.html',
  styleUrls: ['./edit-enquiry.component.scss']
})
export class EditEnquiryComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @Input() dialogTitle: string = "";
  @Input() theme: string = "silver";
  @Input() isMobile: boolean = false;
  @Input() enquiryToEdit: Enquiry = new Enquiry();
  @Input() enquiryForm: DialogForm[] = new Array();
  @Input() itemToDelete: string = "";
  @Input() roundDigitsForEnquiryEditGrid: RoundDigit[] = new Array();
  @Input() roundDigitsForItemEditGrid: RoundDigit[] = new Array();
  @Input() roundDigitsForItemForm: RoundDigit[] = new Array();
  @Input() roundDigitsForEditInPlace: RoundDigit[] = new Array();
  @Input() roundDigitsForEnquiryForm: RoundDigit[] = new Array();
  @Input() showAIDialog: boolean = false;
  @Input() openEditPricesTrigger: number = 0;


  @Output() returnEnquiryBookClick: EventEmitter<any> = new EventEmitter();
  @Output() reloadEnquiry: EventEmitter<string> = new EventEmitter();
  @Output() dialogButtonClick: EventEmitter<any> = new EventEmitter();
  @Output() searchSimilarEnquiriesClick: EventEmitter<any> = new EventEmitter();
  @Output() onOpenITDCR: EventEmitter<OpenItdcrEvent> = new EventEmitter();



  subscriptions: Subscription = new Subscription();
  headerParametersValues: HeaderParametersValues = new HeaderParametersValues();
  itemParameterValues: ItemParametersValues = new ItemParametersValues();
  itemParameterLengthValues: ItemParametersLengthValues = new ItemParametersLengthValues();
  materials: Material[] = new Array();


  dialogIcon: string = "fal fa-pencil-alt";
  showEditDialog: boolean = false;
  showSpecialRequirements: boolean = false;

  columnsToShowHeader: string[] = ["enquiryNo", "salesPerson", "salesOffice", "customer.customerName", "customer.customerCode", "customer.isDummy",
    "customer.customerCountry.countryCode", "customer.customerCountry.countryName", "unitSystem", "currency",
    "dueDate", "creationDate", "lastRevisionDate", "offerValidityDate", "mstOfferStatus", "projectName", "offerScheme.offerSchemeDescription","bonusScheme.bonusSchemeDescription", "orderReason", "applicableNorms", "normGrades.normGradeCode", "rawMaterialGrade",
    "od", "wt", "id", "npsSchedule.npsDescription", "sms.marketingRoute", "sms.description", "marketFamily.name", "totalWeight", "totalWeightUom", "remark", "quotationEnquiryNo"];
  columnsNps: string[] = ["npsScheduleId", "npsDescription", "nps", "schedule", "odMetric", "wtMetric", "odImperial", "wtImperial"];
  columnsToHideNps: string[] = ["npsScheduleId", "schedule", 'nps'];
  columnsToFilterNps: string[] = ["npsDescription"];
  dataSet: any[] = new Array();
  elementPerRow: number = 5;
  dialogButtons: DialogButton[] = new Array();
  dtFormat: string = "yyyy-MM-dd";
  isFormReady: boolean = false;
  oldEnquiryForm: DialogForm[] = new Array();
  showSelectNps: boolean = false;
  dataSetCustomers: any[] = new Array();
  showSelectCustomer: boolean = false;
  dataSetNps: any[] = new Array();
  selectedNpsRow: NpsAndSchedule = new NpsAndSchedule();
  prevToogleButton: string = "";
  columnsToHideItems: string[] = ['normGrades.normGradeId', 'marketingGrade.marketingGradeId', 'marketingGrade.marketingGradeCode', 'marketingGrade.isDefault', 'rawMaterialGrade.rawMaterialGradeId',
    'rawMaterialGrade.isDefault', 'npsSchedule.npsScheduleId', 'npsSchedule.nps', 'npsSchedule.schedule', 'npsSchedule.odMetric', 'npsSchedule.wtMetric', 'npsSchedule.odImperial', 'npsSchedule.wtImperial',
    'sms.smsId', 'sms.description', 'sms.marketingRoute', 'marketFamily.marketFamilyId', 'marketFamily.description', 'marketFamily.isDefaultForProject', 'marketFamily.isDefaultForStock',
    'surfaceType.surfaceTypeId', 'surfaceType.description', 'sql.sqlId', 'mill.millId', 'mill.name', 'mill.city', 'mill.country', 'Attachments', 'marketingGrade', 'gradeCustomerAnalysisLimitation.isCustom',
    'gradeCustomerOtherLimitation.isCustom', 'tubeExecution.tubeExecutionId', 'tubeExecution.name', 'tubeExecution.isCustom', 'tubeExecution.toleranceMinusAw', 'tubeExecution.tolerancePlusAw',
    'tubeExecution.toleranceMinusMw', 'tubeExecution.tolerancePlusMw', 'tubeExecution.isDefaultForHot', 'tubeExecution.isDefaultForCold', 'weightPerLengthUom', 'totalLength',
    'totalLengthUom', 'energySurchargeValue', 'finalPricePerLengthUoM', 'totalPrice', 'totalPriceUoM', 'extraCostsCollection', "fullCost", "extraCosts", "minimumFm", "recommendedFm", "customerBonus", "minimumPrice", "recommendedPrice", "actualFm", 'finalPrice', 'sourceItemNo', 'isCostsSourceManuallySelected'];
  /* 'npsSchedule', */
  columnsToShowItem: string[] = ["customerItemNo", "feasibilityStatus", "costsStatus", "deliveryStatus", "unitSystem", "material.materialCode", "marketingRoute", "sms.description", "marketFamily.name", "customerDeliveryDate", "energySurcharge", "applicableNorms", "remark", "normGrades.normGradeCode", "gradeCustomerAnalysisLimitation.limitation",
    "gradeCustomerOtherLimitation.limitation", "rawMaterialGrade.rawMaterialGradeCode", "npsSchedule.npsDescription", "od", "odTolerancePlus", "odToleranceMinus", "odToleranceUom", "id", "idTolerancePlus", "idToleranceMinus", "idToleranceUom", "wt", "typeOfTolerance", "tubeExecution.description", "wtTolerancePlus", "wtToleranceMinus", "wtToleranceUom",
    "quantity", "quantityUom", "lengthType", "multipleLength", "lengthMin", "lengthMax", "lengthNominal", "uBent", "totalWeight", "totalWeightUom", "mill.shortName", "surfaceType.name", "cts", "endsCondition", "testCondition", "sql.name", "offerScheme.offerSchemeDescription", "ut", "hydroTest", "ht", "htAdditional", 'dyePenetrant', 'dyePenetrant100P', 'penalty', 'colorCoding', 'specialOperations', 'specialTests', 'grindingHoning', 'ec', 'notStdPackaging', 'inspectionType3Dot2', 'multipleCutting',
    "icrIssued", "itrIssued", "idrIssued", "fullCost", "extraCosts", "minimumFm", "recommendedFm", "customerBonus", "minimumPrice", "recommendedPrice", "actualFm", "actualFmAmountPerWeight", "negotiationMargin", "agentFee", 'finalPrice', 'finalPricePerLength', 'totalPrice', 'alloySurchargeValue', 'energySurchargeValue', "initialPrice", "previousRevisionPrice", "extraLeadTime", "deliveryDate", "deliveryNotes"];
  columnsToShowItemEditInPlace: string[] = ["customerItemNo", 'energySurcharge', 'applicableNorms', 'remark', "material", 'normGrades', 'gradeCustomerAnalysisLimitation', 'gradeCustomerOtherLimitation',
    'rawMaterialGrade', 'unitSystem', 'quantity', 'quantityUom', 'npsSchedule', 'od',
    'odTolerancePlus', 'odToleranceMinus', 'odToleranceUom', 'id', 'idTolerancePlus', 'idToleranceMinus', 'idToleranceUom',
    'wt', 'typeOfTolerance', 'tubeExecution', 'wtTolerancePlus', 'wtToleranceMinus', 'wtToleranceUom', 'lengthType',
    'multipleLength', 'lengthMin', 'lengthMax', 'lengthNominal', 'marketingRoute', 'sms', 'marketFamily', 'customerDeliveryDate', 'cts', 'endsCondition', 'testCondition', 'sql', 'offerScheme', 'ut',
    'hydroTest', 'ht', 'htAdditional', 'dyePenetrant', 'dyePenetrant100P', 'penalty', 'colorCoding', 'specialOperations', 'specialTests', 'grindingHoning', 'ec', 'notStdPackaging', 'inspectionType3Dot2', 'multipleCutting', 'uBent', 'surfaceType', 'mill', "totalWeightUom"
  ];
  itemPriceVisibleColumns: string[] = ["customerItemNo", "unitSystem", "material.materialCode", "sms.description", "marketFamily.name", "customerDeliveryDate", "energySurcharge", "applicableNorms", "remark", "normGrades.normGradeCode", "gradeCustomerAnalysisLimitation.limitation",
    "gradeCustomerOtherLimitation.limitation", "rawMaterialGrade.rawMaterialGradeCode", "npsSchedule.npsDescription", "od", "odTolerancePlus", "odToleranceMinus", "odToleranceUom", "id", "idTolerancePlus", "idToleranceMinus", "idToleranceUom", "wt", "typeOfTolerance", "tubeExecution.description", "wtTolerancePlus", "wtToleranceMinus", "wtToleranceUom",
    "quantity", "quantityUom", "lengthType", "multipleLength", "lengthMin", "lengthMax", "lengthNominal", "uBent", "totalWeight", "totalWeightUom", "mill.shortName", "surfaceType.name", "cts", "endsCondition", "testCondition", "sql.name", "offerScheme.offerSchemeDescription", "ut", "hydroTest", "ht", "htAdditional", 'dyePenetrant', 'dyePenetrant100P', 'penalty', 'colorCoding', 'specialOperations', 'specialTests', 'grindingHoning', 'ec', 'notStdPackaging', 'inspectionType3Dot2', 'multipleCutting', "extraLeadTime", "deliveryNotes"];
  itemCostsVisibileColumns: string[] = ["fullCost", "extraCosts", "minimumFm", "recommendedFm", "customerBonus", "minimumPrice", "recommendedPrice", "actualFm", "actualFmAmountPerWeight", "negotiationMargin", "agentFee", "finalPrice", "finalPricePerLength", 'alloySurchargeValue', 'energySurchargeValue', 'initialPrice', "previousRevisionPrice", "extraLeadTime", "deliveryDate", "deliveryNotes"];


  // editableFields: string[] = []; // ["finalPrice"];
  headerAndItemParametersReady = false;
  dataSetItems: any[] = new Array();
  enquiryTotals: EnquiryTotalPriceAndMargin | null = null;
  enquiryTotalPriceFormatted: string = '';
  enquiryTotalMarginFormatted: string = '';
  enquiryTotalMarginClass: string = '';
  customIcoCols: CustomIcoCol[] = new Array();
  showModalItem: boolean = false;
  items: EnquiryHeaderItem[] = new Array();
  itemAction: string = "";
  selectedIndexItem: number = -1;
  showEditInPlace: boolean = false;
  showEditCosts: boolean = false;
  showExtraCosts: boolean = false;
  showOrderExtraCosts: boolean = false;
  showItemDeliveryDates: boolean = false;
  showUploadFromAI: boolean = false;
  showCostingToolModal: boolean = false;
  showItdcrViewerModal: boolean = false;
  itdcrViewerNo: string = '';
  itdcrViewerShowHistory: boolean = true;
  costingToolItem: EnquiryHeaderItem | null = null;
  selectedExtraCostItem: EnquiryHeaderItem | null = null;
  selectedDeliveryDatesItem?: EnquiryHeaderItem | null = null;
  columnsRequired: string[] = ['customerItemNo', 'energySurcharge', 'normGrades', 'rawMaterialGrade', 'unitSystem', 'quantity', 'quantityUom', 'lengthType', 'lengthMin', 'lengthMax', 'lengthUom',
    'sms', 'marketFamily', 'endsCondition', 'surfaceType', 'sql', 'offerScheme', 'mill', 'totalWeight', 'totalWeightUom',
    'od', 'odUom', 'id', 'idUom', 'wt', 'wtUom', 'gradeCustomerAnalysisLimitation', 'gradeCustomerOtherLimitation', 'uBent',
    'ut', 'hydroTest', 'ht', 'htAdditional', 'dyePenetrant', 'dyePenetrant100P', 'penalty', 'colorCoding',
    'specialOperations', 'specialTests', 'grindingHoning', 'ec', 'notStdPackaging', 'inspectionType3Dot2', 'multipleCutting'];

  columnsSelect: string[] = ['unitSystem', 'marketingRoute', 'sms', 'quantityUom', 'odUom', 'odToleranceUom', 'idUom', 'idToleranceUom', 'wtUom', 'wtToleranceUom', 'totalWeightUom', 'typeOfTolerance', 'marketFamily', 'endsCondition'
    , 'lengthType', 'lengthUom', 'surfaceType', 'gradeCustomerAnalysisLimitation', 'gradeCustomerOtherLimitation', 'tubeExecution', 'testCondition', 'sql', 'offerScheme'];
  columnsBoolean: string[] = ['uBent', 'energySurcharge', 'multipleLength', 'cts', 'ut', 'hydroTest', 'ht', 'htAdditional', 'dyePenetrant', 'dyePenetrant100P', 'penalty', 'colorCoding', 'specialOperations', 'specialTests', 'grindingHoning', 'ec', 'notStdPackaging', 'inspectionType3Dot2', 'multipleCutting'];

  calculatedCols: CalculatedCols[] = new Array();
  topPx: number = 0;
  itemsFromXlsx?: ItemsFromXlsx = new ItemsFromXlsx();
  waitingEditInPlaceGridReady: boolean = false;
  itemsPricesFromXlsx?: ItemsPricesFromXlsx;
  limitationsForNormGrades: LimitationsForNormGrades = new LimitationsForNormGrades();
  itemsToEdit: EnquiryHeaderItem[] = new Array();
  previousFinalPrice?: number;


  itemFieldsExtraCostsMap: any = {
    ut: "UT Extra Cost",
    hydroTest: "Hydro Extra Cost",
    ht: "Sep.HT Extra Cost",
    htAdditional: "Add. HT Extra Cost"
  }

  // SUBSCRIPTION
  subsGetNormGrades = new Subscription();
  subsUpdEnquiryItems = new Subscription();
  subsDwnlItems = new Subscription();
  subsUplItems = new Subscription();
  subsGetRawMaterial = new Subscription();
  subsGetNps = new Subscription();
  subsEditEnquiry = new Subscription();
  salesOfficeId?: number | null;
  itemButtonsDisabled: boolean = false;
  discardEditChanges: boolean = false;
  priceEdited: boolean = false;
  isCalculatingMargins: boolean = false;
  private pendingPriceCalculations = 0;
  private processedOpenEditPricesTrigger = 0;
  private openEditPricesPending = false;

  enquiryAttachments: EnquiryAttachment[] = new Array();

  // custom render header for items
  @ViewChild('viewCostHeader', { static: true }) viewCostHeader!: TemplateRef<any>;
  @ViewChild('viewExtraCostsHeader', { static: true }) viewExtraCostsHeader!: TemplateRef<any>;
  // custom render cells for items

  @ViewChild('viewMismatch', { static: true }) viewMismatchCheckTemplate!: TemplateRef<any>;
  @ViewChild('viewMargin', { static: true }) viewMarginTemplate!: TemplateRef<any>;
  @ViewChild('viewCost', { static: true }) viewCostTemplate!: TemplateRef<any>;
  @ViewChild('viewCostNumeric', { static: true }) viewCostNumericTemplate!: TemplateRef<any>;
  @ViewChild('viewExtraCosts', { static: true }) viewExtraCostsTemplate!: TemplateRef<any>;
  @ViewChild('viewActualCm', { static: true }) viewActualCmTemplate!: TemplateRef<any>;
  @ViewChild('viewFinalPrice', { static: true }) viewFinalPriceTemplate!: TemplateRef<any>;
  @ViewChild('viewDeliveryDates', { static: true }) viewDeliveryDates!: TemplateRef<any>;
  @ViewChild('viewExtraLeadTime', { static: true }) viewExtraLeadTime!: TemplateRef<any>;
  @ViewChild('viewDeliveryNotes', { static: true }) viewDeliveryNotes!: TemplateRef<any>;

  private readonly costHeaderUomByColumn: { [key: string]: string } = {
    initialPrice: 'costsUom',
    previousRevisionPrice: 'costsUom',
    finalPricePerLength: 'finalPricePerLengthUom',
    totalPrice: 'totalPriceUom',
    alloySurchargeValue: 'costsUom',
    energySurchargeValue: 'costsUom',
    fullCost: 'costsUom',
    minimumPrice: 'costsUom',
    recommendedPrice: 'costsUom',
    extraCosts: 'costsUom',
    finalPrice: 'costsUom',
    actualFmAmountPerWeight: 'costsUom'
  };

  customHeaderRenderers = {
    initialPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'initialPrice' }
      };
    },
    previousRevisionPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'previousRevisionPrice' }
      };
    },
    finalPricePerLength: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'finalPricePerLength' }
      };
    },
    totalPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'totalPrice' }
      };
    },
    alloySurchargeValue: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'alloySurchargeValue' }
      };
    },
    energySurchargeValue: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'energySurchargeValue' }
      };
    },
    fullCost: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'fullCost' }
      };
    },
    minimumPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'minimumPrice' }
      };
    },
    recommendedPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'recommendedPrice' }
      };
    },
    extraCosts: () => {
      return {
        template: this.viewExtraCostsHeader,
        context: { column: 'extraCosts' }
      };
    },
    finalPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'finalPrice' }
      };
    },
    actualFmAmountPerWeight: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'actualFmAmountPerWeight' }
      };
    }
  }

  customRenderers = {
    ut: (row: any) => {
      return {
        template: this.viewMismatchCheckTemplate,
        context: { $implicit: row, column: 'ut' }
      };
    },
    hydroTest: (row: any) => {
      return {
        template: this.viewMismatchCheckTemplate,
        context: { $implicit: row, column: 'hydroTest' }
      };
    },
    ht: (row: any) => {
      return {
        template: this.viewMismatchCheckTemplate,
        context: { $implicit: row, column: 'ht' }
      };
    },
    htAdditional: (row: any) => {
      return {
        template: this.viewMismatchCheckTemplate,
        context: { $implicit: row, column: 'htAdditional' }
      };
    },
    extraLeadTime: (row: any) => {
      return {
        template: this.viewExtraLeadTime,
        context: { $implicit: row, column: 'extraLeadTime' }
      };
    },
    deliveryNotes: (row: any) => {
      return {
        template: this.viewDeliveryNotes,
        context: { $implicit: row, column: 'deliveryNotes' }
      };
    },
    negotiationMargin: (row: any) => {
      return {
        template: this.viewMarginTemplate,
        context: { $implicit: row, column: 'negotiationMargin' }
      };
    },
    agentFee: (row: any) => {
      return {
        template: this.viewMarginTemplate,
        context: { $implicit: row, column: 'agentFee' }
      };
    },
    initialPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'initialPrice' }
      };
    },
    previousRevisionPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'previousRevisionPrice' }
      };
    },
    finalPricePerLength: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'finalPricePerLength', uomColumn: 'finalPricePerLengthUom' }
      };
    },
    totalPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'totalPrice', uomColumn: 'totalPriceUom' }
      };
    },
    deliveryDate: (row: any) => {
      return {
        template: this.viewDeliveryDates,
        context: { $implicit: row, column: 'delilveryDate' }
      };
    },
    alloySurchargeValue: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: {
          $implicit: row,
          column: 'alloySurchargeValue',
          warningClass: this.isAlloySurchargeWarning(row?.alloySurchargeValue) ? 'warning-border' : ''
        }
      };
    },
    energySurchargeValue: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'energySurchargeValue' }
      };
    },
    fullCost: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'fullCost' }
      };
    },
    minimumPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'minimumPrice' }
      };
    },
    recommendedPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'recommendedPrice' }
      };
    },
    extraCosts: (row: any) => {
      return {
        template: this.viewExtraCostsTemplate,
        context: { $implicit: row }
      };
    },
    actualFm: (row: any) => {
      return {
        template: this.viewActualCmTemplate,
        context: { $implicit: row, column: 'actualFm' }
      };
    },
    finalPrice: (row: any) => {
      return {
        template: this.viewFinalPriceTemplate,
        context: { $implicit: row }
      };
    },
    actualFmAmountPerWeight: (row: any) => {
      return {
        template: this.viewActualCmTemplate,
        context: { $implicit: row, column: 'actualFmAmountPerWeight' }
      };
    }
  };

  constructor(private translate: TranslateService, private backendService: BackendService, private datePipe: DatePipe, private teiasoftLoader: TeiasoftLoaderService,
    public globals: Globals, private teiasoftToaster: TeiasoftToasterService, private teiasoftModalService: TeiasoftModalService, private utils: UtilsService, private rawMaterialGradeService: RawMaterialGradesService, private router: Router) {
    //this.dialogTitle = this.translate.instant("enquiryBook.editEnquiry");
    this.topPx = window.scrollY;
    $('body').addClass('no-scroll');

    this.getHeaderParametersValues();
    this.buildCustomIconGrid();
    this.buildCalculatedCols();

  }

  ngOnInit(): void {
    this.showUploadFromAI = this.showAIDialog;
  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {
    $('body').removeClass('no-scroll');

    this.subscriptions.unsubscribe();

    this.enquiryToEdit = new Enquiry();
    this.enquiryForm = new Array();
    this.headerParametersValues = new HeaderParametersValues();
    this.itemParameterValues = new ItemParametersValues();
    this.dialogButtons = new Array();
    this.oldEnquiryForm = new Array();
    this.dataSetCustomers = new Array();
    this.dataSetNps = new Array();
    this.dataSetItems = new Array();
    this.customIcoCols = new Array();
    this.items = new Array();
    this.calculatedCols = new Array();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["openEditPricesTrigger"]) {
      const trigger = Number(changes["openEditPricesTrigger"].currentValue || 0);
      if (trigger > this.processedOpenEditPricesTrigger) {
        this.openEditPricesPending = true;
      }
    }

    if (changes && changes["enquiryToEdit"]) {
      this.enquiryToEdit = new Enquiry();
      this.enquiryToEdit = changes["enquiryToEdit"].currentValue;
      this.dialogTitle = this.translate.instant("enquiryBook.editEnquiry") + " - " + this.enquiryToEdit.enquiryNo!;
      this.enquiryAttachments = new Array();
      this.enquiryAttachments = JSON.parse(JSON.stringify(this.enquiryToEdit.header!.enquiryAttachments!));
      this.fillDataSet();
      this.fillDataSetItems();
      this.loadEnquiryTotals();
      this.tryOpenEditPricesFromTrigger();
    }

    if (changes && changes["enquiryForm"]) {
      this.enquiryForm = new Array();
      this.enquiryForm = changes["enquiryForm"].currentValue;
    }

    if (changes && changes["roundDigitsForEnquiryEditGrid"]) {
      this.roundDigitsForEnquiryEditGrid = new Array();
      this.roundDigitsForEnquiryEditGrid = changes["roundDigitsForEnquiryEditGrid"].currentValue;
      this.setRoundDigitsEnquiryGrid();
    }

    if (changes && changes["roundDigitsForEnquiryForm"]) {
      this.roundDigitsForEnquiryForm = new Array();
      this.roundDigitsForEnquiryForm = changes["roundDigitsForEnquiryForm"].currentValue;
    }

    if (changes && changes["roundDigitsForItemEditGrid"]) {
      this.roundDigitsForItemEditGrid = new Array();
      this.roundDigitsForItemEditGrid = changes["roundDigitsForItemEditGrid"].currentValue;
      this.setRoundDigitsItemGrid();
    }

    if (changes && changes["roundDigitsForEditInPlace"]) {
      this.roundDigitsForEditInPlace = new Array();
      this.roundDigitsForEditInPlace = changes["roundDigitsForEditInPlace"].currentValue;
    }

    if (changes && changes["roundDigitsForItemForm"]) {
      this.roundDigitsForItemForm = new Array();
      this.roundDigitsForItemForm = changes["roundDigitsForItemForm"].currentValue;
    }

    if (changes && changes["headerParametersValues"]) {
      this.headerParametersValues = new HeaderParametersValues();
      this.headerParametersValues = changes["headerParametersValues"].currentValue;
    }

    if (changes && changes["itemParameterValues"]) {
      this.itemParameterValues = new ItemParametersValues();
      this.itemParameterValues = changes["itemParameterValues"].currentValue;
    }

    if (changes && changes["itemToDelete"] && changes["itemToDelete"].currentValue != changes["itemToDelete"].previousValue) {
      this.itemToDelete = changes["itemToDelete"].currentValue;
      if (this.itemToDelete != '' && this.itemToDelete != '---') this.prepareItems('delete');
    }
  }

  private tryOpenEditPricesFromTrigger(): void {
    if (!this.openEditPricesPending) {
      return;
    }
    this.openEditPricesPending = false;
    this.processedOpenEditPricesTrigger = Number(this.openEditPricesTrigger || 0);
    if (this.atLeastOneCostValid()) {
      this.onEditCostsClick();
    }
  }

  getBooleanValueLabel(value: any): string {
    if (value === true) return this.translate.instant("noTranslations.yes");
    if (value === false) return this.translate.instant("noTranslations.no");

    return '';
  }

  getCostColumnHeaderLabel(column: string): string {
    const baseLabel = this.getTranslatedColumnLabelWithoutUom(column);
    const uomColumn = this.costHeaderUomByColumn[column];
    const uomValue = this.getCostColumnUom(uomColumn);
    return uomValue ? `${baseLabel} (${uomValue})` : baseLabel;
  }

  private getCostColumnUom(uomColumn?: string): string {
    if (!uomColumn) {
      return '';
    }

    const fromGrid = this.dataSetItems.find(item => !!item?.[uomColumn])?.[uomColumn];
    if (fromGrid) {
      return fromGrid;
    }

    const fromItems = this.enquiryToEdit?.items?.find(item => !!(item as any)?.[uomColumn]) as any;
    return fromItems?.[uomColumn] ?? '';
  }

  private getTranslatedColumnLabelWithoutUom(column: string): string {
    const translationKey = 'grid.' + column.charAt(0).toUpperCase() + column.slice(1);
    const translatedLabel = this.translate.instant(translationKey);
    return this.stripHardcodedUomSuffix(translatedLabel);
  }

  private stripHardcodedUomSuffix(label: string): string {
    return (label || '').replace(/\s*\(?[^\s()]+\/[^\s()]+\)?\s*$/, '').trim();
  }

  hasMismatch(row: any, column: string): boolean {

    // check column and relative ct value 
    if (row[column] != undefined && row[column + 'Ct'] != undefined) {

      // if they are defined 
      const toBooleanLike = (input: any): any => {
        if (typeof input === 'boolean') {
          return input;
        }
        if (typeof input === 'number') {
          if (input === 1) return true;
          if (input === 0) return false;
        }
        if (typeof input === 'string') {
          const normalized = input.trim().toLowerCase();
          if (['true', 'yes', 'y', '1'].includes(normalized)) return true;
          if (['false', 'no', 'n', '0'].includes(normalized)) return false;
        }
        return input;
      };

      const value = toBooleanLike(row[column]);
      const ctValue = toBooleanLike(row[column + 'Ct']);
      const ctValueMissing = row[column + 'Ct'] == null || (typeof row[column + 'Ct'] === 'string' && row[column + 'Ct'].trim() === '');
      if (ctValueMissing) return false; // MP: when ct column has no value we don't show any mismatch because they cannot be compared

      const matching = value === ctValue;
      const item = this.enquiryToEdit?.items?.find(i => i.itemNo == row['itemNo']);
      const extraCost = item?.extraCostsCollection?.find(ex => ex.extraCostName == this.itemFieldsExtraCostsMap[column]);


      if (!matching) {
        if ((!extraCost || extraCost.extraCostAmount == 0)) {
          return true;
        }
      }
      if (matching) {
        // extra cost should be null or 0
        if (extraCost && extraCost.extraCostAmount != 0) {
          return true;
        }
      }

    }

    return false;
  }

  getHeaderParametersValues(): Promise<HeaderParametersValues> {
    this.teiasoftLoader.start();
    return new Promise((resolve, reject) => {
      this.subscriptions.add(this.backendService.getHeaderParametersValues().subscribe(res => {
        this.headerParametersValues = new HeaderParametersValues();
        if (res) {
          res.countries?.sort((a, b) => {
            if (a.countryName! < b.countryName!) {
              return -1;
            }
            if (a.countryName! > b.countryName!) {
              return 1;
            }
            return 0;
          });
          this.headerParametersValues = res;
          this.getItemParametersLengthValues()
            .then(() => this.getMaterials())
            .then(() => this.getItemParametersValues())
            .then(() => { resolve(res) }) // resolve finally when item parameters got retrieved
            .catch(err => {
              this.teiasoftLoader.stop();
              reject(err);
            });
        }
      }, err => {
        this.teiasoftLoader.stop();
        reject(err);
      }));
    });

  }

  getItemParametersValues(): Promise<ItemParametersValues> {
    return new Promise((resolve, reject) => {
      this.subscriptions.add(this.backendService.getItemParametersValues().subscribe(res => {
        this.itemParameterValues = new ItemParametersValues();
        this.itemParameterValues = res;
        this.headerAndItemParametersReady = true;
        this.teiasoftLoader.stop();
        resolve(res);
      }, err => {
        reject(err);
      }))
    });
  }

  getItemParametersLengthValues(): Promise<ItemParametersLengthValues> {
    return new Promise((resolve, reject) => {
      this.subscriptions.add(this.backendService.getItemParametersLengthValues().subscribe(res => {
        this.itemParameterLengthValues = new ItemParametersLengthValues();
        this.itemParameterLengthValues = res;
        resolve(res);
      }, err => {
        reject(err);
      }))
    });
  }


  getMaterials(): Promise<Materials> {
    return new Promise((resolve, reject) => {
      this.subscriptions.add(this.backendService.getMaterials().subscribe(res => {
        this.materials = new Array();
        this.materials = res.materials || [];
        resolve(res);
      }, err => {
        reject(err);
      }))
    });
  }

  fillDataSet() {
    this.dataSet = new Array();
    let _dataSet: GridDataset = new GridDataset();
    let _obj: EnquiryHeader = new EnquiryHeader();
    _obj = this.enquiryToEdit.header!;
    for (const key in _obj) {
      let _value: any = _obj[key as keyof typeof _obj];
      if (_value == null) _value = "";
      let _typeOf: string = typeof _value;
      let _key: string = "";
      if (_typeOf != 'object') {
        _dataSet[key] = _value;
      } else {
        if (Array.isArray(_value)) {
          _key = key;
          if (_value.length == 0) {
            _dataSet[_key] = '';
          }
          if (_value.length > 0 && key.toLowerCase() == 'attachments') {
            _dataSet[_key] = _value.length;
          } else {
            for (const key2 in _value[0]) {
              _key = key + "." + key2;
              //_dataSet[key2] = _value.map(x => x[key2]).join(',');
              _dataSet[_key] = _value.map(x => x[key2]).join(',');
            }
          }
        } else {
          for (const key3 in _value) {
            _key = key + "." + key3;
            if (typeof _value[key3] != 'object') {
              let _value3: any = _value[key3 as keyof typeof _value];
              //_dataSet[key3] = _value3;
              _dataSet[_key] = _value3;
            } else {
              for (const key4 in _value[key3]) {
                _key = key + "." + key3 + "." + key4;
                let _value4: any = _value[key3][key4]; //_value[key4 as keyof typeof key4];
                //_dataSet[key4] = _value4;
                _dataSet[_key] = _value4;
              }
            }
          }
        }
      }

    }
    this.dataSet.push(_dataSet);
    _obj = new EnquiryHeader();
    _dataSet = new GridDataset();
    this.setRoundDigitsEnquiryGrid();
    let _i: number = this.enquiryForm.findIndex(x => x.field == 'salesOfficeId');
    if (_i != -1) {
      this.salesOfficeId = this.enquiryForm[_i].value!;
    }

  }

  setRoundDigitsEnquiryGrid() {
    // ROUND DIGITS
    if (!this.roundDigitsForEnquiryEditGrid || this.roundDigitsForEnquiryEditGrid.length == 0) return;
    if (!this.dataSet || this.dataSet.length == 0) return;

    for (var k = 0; k < this.dataSet.length; k++) {
      let _unitSystem: string = this.dataSet[k]["unitSystem"];
      for (const prop in this.dataSet[k]) {
        let _i: number = this.roundDigitsForEnquiryEditGrid.findIndex(x => x.fieldName?.toLowerCase() == prop.toLowerCase());
        if (_i != -1) {
          if (_unitSystem == 'Metric' && this.dataSet[k][prop] != null && this.dataSet[k][prop] != '')
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop]).toFixed(this.roundDigitsForEnquiryEditGrid[_i].metricDigits!);

          if (_unitSystem == 'Imperial' && this.dataSet[k][prop] != null && this.dataSet[k][prop] != '')
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop]).toFixed(this.roundDigitsForEnquiryEditGrid[_i].imperialDigits!);
        } /* else {
          if (_unitSystem == 'Metric' && this.dataSet[k][prop] != null)
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop].toFixed(2));
          
          if (_unitSystem == 'Imperial' && this.dataSet[k][prop] != null)
            this.dataSet[k][prop] = parseFloat(this.dataSet[k][prop].toFixed(2));
        } */
      }
    }

  }

  setRoundDigitsItemGrid() {
    // ROUND DIGITS
    if (!this.roundDigitsForItemEditGrid || this.roundDigitsForItemEditGrid.length == 0) return;
    if (!this.dataSetItems || this.dataSetItems.length == 0) return;

    for (var k = 0; k < this.dataSetItems.length; k++) {
      let _unitSystem: string = this.dataSetItems[k]["unitSystem"];
      for (const prop in this.dataSetItems[k]) {
        let _i: number = this.roundDigitsForItemEditGrid.findIndex(x => x.fieldName?.toLowerCase() == prop.toLowerCase());
        if (_i != -1) {
          if (_unitSystem == 'Metric' && this.dataSetItems[k][prop] != null && this.dataSetItems[k][prop] != '' && this.dataSetItems[k][prop] != undefined)
            this.dataSetItems[k][prop] = Number.parseFloat(this.dataSetItems[k][prop]).toFixed(this.roundDigitsForItemEditGrid[_i].metricDigits!); //parseFloat(this.dataSetItems[k][prop].toFixed(this.roundDigitsForItemEditGrid[_i].metricDigits!));

          if (_unitSystem == 'Imperial' && this.dataSetItems[k][prop] != null && this.dataSetItems[k][prop] != '' && this.dataSetItems[k][prop] != undefined)
            this.dataSetItems[k][prop] = Number.parseFloat(this.dataSetItems[k][prop]).toFixed(this.roundDigitsForItemEditGrid[_i].imperialDigits!); // parseFloat(this.dataSetItems[k][prop].toFixed(this.roundDigitsForItemEditGrid[_i].imperialDigits!));
        } /* else {
              if (_unitSystem == 'Metric' && this.dataSetItems[k][prop] != null)
                this.dataSetItems[k][prop] = parseFloat(this.dataSetItems[k][prop].toFixed(2));
              
              if (_unitSystem == 'Imperial' && this.dataSetItems[k][prop] != null)
                this.dataSetItems[k][prop] = parseFloat(this.dataSetItems[k][prop].toFixed(2));
            } */
      }
    }
  }

  setRoundDigitsEnquiryForm() {
    // ROUND DIGITS
    if (!this.roundDigitsForEnquiryForm || this.roundDigitsForItemEditGrid.length == 0) return;
    if (!this.enquiryForm || this.enquiryForm.length == 0) return;

    console.log("QFrom", this.roundDigitsForEnquiryForm);
    let _i: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() == 'unitsystem');
    let _unitSystem: string = this.enquiryForm[_i].value!;
    for (var k = 0; k < this.enquiryForm.length; k++) {
      _i = this.roundDigitsForEnquiryForm.findIndex(x => x.fieldName?.toLowerCase() == this.enquiryForm[k].field!.toLowerCase());
      if (_i != -1) {
        if (_unitSystem == 'Metric' && this.enquiryForm[k].value! != null && this.enquiryForm[k].value! != '' && this.enquiryForm[k].value! != undefined) {
          this.enquiryForm[k].value = Number.parseFloat(this.enquiryForm[k].value!).toFixed(this.roundDigitsForEnquiryForm[_i].metricDigits!);
          this.enquiryForm[k].roundDigits = this.roundDigitsForEnquiryForm[_i].metricDigits!;
        }

        if (_unitSystem == 'Imperial' && this.enquiryForm[k].value! != null && this.enquiryForm[k].value! != '' && this.enquiryForm[k].value! != undefined) {
          this.enquiryForm[k].value = Number.parseFloat(this.enquiryForm[k].value!).toFixed(this.roundDigitsForEnquiryForm[_i].imperialDigits!);
          this.enquiryForm[k].roundDigits = this.roundDigitsForEnquiryForm[_i].imperialDigits!;
        }
      }
    }
  }

  fillFormEdit() {
    if (this.enquiryForm.length == 0) return;
    let _i: number = 0;

    // CHECK IF CUSTOMER STILL IS IN LIST
    let _iC: number = this.headerParametersValues.customers!.findIndex(x => x.customerId == this.enquiryToEdit.header!.customer!.customerId!);

    const odIdWtDefaultUom = this.enquiryToEdit.header?.unitSystem == 'Metric' ? this.itemParameterValues.odUoms?.metricUoms?.find(u => u.isDefault)?.uomCode : this.itemParameterValues.odUoms?.imperialUoms?.find(u => u.isDefault)?.uomCode;

    /*  _i = this.enquiryForm.findIndex(x => x.field == 'customerId');
    this.enquiryForm[_i].value = _iC != -1 ? this.enquiryToEdit.header!.customer!.customerId : null;
    this.enquiryForm[_i].text = _iC != -1 ? this.enquiryToEdit.header!.customer!.customerId!.toString() : null;
  
    _i = this.enquiryForm.findIndex(x => x.field == 'customerName');
    this.enquiryForm[_i].value = _iC != -1 ? this.enquiryToEdit.header!.customer!.customerName : null;
    this.enquiryForm[_i].text = _iC != -1 ? this.enquiryToEdit.header!.customer!.customerName! : null;
    this.enquiryForm[_i].disabled = false;
    this.enquiryForm[_i].readOnly = _iC != -1 ? true : false;
    this.enquiryForm[_i].isRequired = _iC != -1 ? false : true; */

    _i = this.enquiryForm.findIndex(x => x.field == 'customerId');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.customer!.customerId;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.customer!.customerId!.toString();

    _i = this.enquiryForm.findIndex(x => x.field == 'customerName');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.customer!.customerName;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.customer!.customerName!;
    this.enquiryForm[_i].disabled = false;
    this.enquiryForm[_i].readOnly = true
    this.enquiryForm[_i].isRequired = true;

    _i = this.enquiryForm.findIndex(x => x.field == 'customerEnquiryNo');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.customerEnquiryNo!;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.customerEnquiryNo!;

    _i = this.enquiryForm.findIndex(x => x.field == 'mstOfferStatus');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.mstOfferStatus!;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.mstOfferStatus!;
    this.enquiryForm[_i].disabled = false;
    this.enquiryForm[_i].readOnly = true;
    this.enquiryForm[_i].isRequired = false;

    _i = this.enquiryForm.findIndex(x => x.field == 'customerCountry');
    this.enquiryForm[_i].value = _iC != -1 ? this.enquiryToEdit.header!.customer!.customerCountry!.countryId : null
    this.enquiryForm[_i].text = _iC != -1 ? this.enquiryToEdit.header!.customer!.customerCountry!.countryName : null;

    _i = this.enquiryForm.findIndex(x => x.field == 'customerCode');
    this.enquiryForm[_i].value = _iC != -1 ? this.enquiryToEdit.header!.customer!.customerCode : null;
    this.enquiryForm[_i].text = _iC != -1 ? this.enquiryToEdit.header!.customer!.customerCode! : null;

    _i = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.unitSystem;
    this.enquiryForm[_i].text = this.translate.instant("enquiryBook." + this.enquiryToEdit.header!.unitSystem);
    this.enquiryForm[_i].readOnly = true;
    this.enquiryForm[_i].isRequired = false;
    this.setSelectUoms();

    _i = this.enquiryForm.findIndex(x => x.field == 'currency');
    if (_i != -1) {
      this.enquiryForm[_i].value = this.enquiryToEdit.header!.currency ?? '';
      this.enquiryForm[_i].text = this.enquiryToEdit.header!.currency ?? '';
      this.enquiryForm[_i].readOnly = true;
      this.enquiryForm[_i].isRequired = false;
    }

    _i = this.enquiryForm.findIndex(x => x.field == 'dueDate');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.dueDate ? this.enquiryToEdit.header!.dueDate : ''; // this.datePipe.transform(this.enquiryToEdit.header!.dueDate!, this.dtFormat)!; 
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.dueDate! ? this.enquiryToEdit.header!.dueDate!.toString() : ''; //this.datePipe.transform(this.enquiryToEdit.header!.dueDate!, this.dtFormat)!; //

    _i = this.enquiryForm.findIndex(x => x.field == 'offerValidityId');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.offerValidity ? this.enquiryToEdit.header!.offerValidity.id : '';
    const lang = this.translate.currentLang;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.offerValidity! ? (this.enquiryToEdit.header!.offerValidity as any)[lang] : '';

    _i = this.enquiryForm.findIndex(x => x.field == 'offerValidityDate');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.offerValidityDate ? this.enquiryToEdit.header!.offerValidityDate : '';
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.offerValidityDate! ? this.enquiryToEdit.header!.offerValidityDate!.toString() : '';


    _i = this.enquiryForm.findIndex(x => x.field == 'salesPerson');
    // MQF-337 
    this.enquiryForm[_i].value = this.headerParametersValues.salesPersons!.filter(x => x.username == this.enquiryToEdit.header!.salesPerson)[0] != undefined ? this.headerParametersValues.salesPersons!.filter(x => x.username == this.enquiryToEdit.header!.salesPerson)[0].userId : 0;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.salesPerson;
    this.enquiryForm[_i].isRequired = true;
    this.enquiryForm[_i].disabled = false;
    if (this.headerParametersValues.salesPersons!.filter(x => x.username == this.enquiryToEdit.header!.salesPerson)[0] == undefined) {
      this.enquiryForm[_i].optionsList = new Array();
      this.enquiryForm[_i].optionsList!.push({ value: 0, text: this.enquiryForm[_i].text });
    }


    _i = this.enquiryForm.findIndex(x => x.field == 'salesOfficeId');
    // MQF-337 
    this.enquiryForm[_i].value = this.headerParametersValues.salesOffices!.filter(x => x.officeCode == this.enquiryToEdit.header!.salesOffice)[0] != undefined ? this.headerParametersValues.salesOffices!.filter(x => x.officeCode == this.enquiryToEdit.header!.salesOffice)[0].officeId! : 0;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.salesOffice;
    this.enquiryForm[_i].isRequired = true;
    this.enquiryForm[_i].disabled = false;
    if (this.headerParametersValues.salesOffices!.filter(x => x.officeCode == this.enquiryToEdit.header!.salesOffice)[0] == undefined) {
      this.enquiryForm[_i].optionsList = new Array();
      this.enquiryForm[_i].optionsList!.push({ value: 0, text: this.enquiryForm[_i].text });
    }

    _i = this.enquiryForm.findIndex(x => x.field == 'projectName');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.projectName;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.projectName!;

    _i = this.enquiryForm.findIndex(x => x.field == 'smsMarketingRoute');
    let _k: number = this.headerParametersValues.sms!.findIndex(x => x.smsId == this.enquiryToEdit.header!.sms!.smsId);
    if (_k != -1) {
      this.enquiryForm[_i].value = this.headerParametersValues.sms![_k].marketingRoute;
      this.enquiryForm[_i].text = this.headerParametersValues.sms![_k].marketingRoute!;
    }

    // GBR 16/02/2024
    // MQF-98 - Se l'oggetto non è nella lista resetto valori e metto il campo a not valid
    _i = this.enquiryForm.findIndex(x => x.field == 'sms');
    _k = this.headerParametersValues.sms!.findIndex(x => x.smsId == this.enquiryToEdit.header!.sms!.smsId);
    if (_k != -1) {
      let _iMr = this.enquiryForm.findIndex(x => x.field == 'smsMarketingRoute');

      this.enquiryForm[_i].value = this.headerParametersValues.sms![_k].smsId;
      this.enquiryForm[_i].text = this.headerParametersValues.sms![_k].description!;
      this.enquiryForm[_i].optionsList = this.getSmsOptionList(this.enquiryForm[_iMr].value);
    } else {
      this.enquiryForm[_i].value = null;
      this.enquiryForm[_i].text = null;
      this.enquiryForm[_i].isValid = this.enquiryForm[_i].isRequired ? false : true;
    }

    _i = this.enquiryForm.findIndex(x => x.field == 'alloySurcharge');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.alloySurcharge;
    this.enquiryForm[_i].text = this.translate.instant("grid." + this.enquiryToEdit.header!.alloySurcharge);

    _i = this.enquiryForm.findIndex(x => x.field == 'orderReason');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.orderReason;
    this.enquiryForm[_i].text = this.translate.instant("grid." + this.enquiryToEdit.header!.orderReason);
    this.enquiryForm[_i].disabled = false;
    this.enquiryForm[_i].readOnly = true;
    this.enquiryForm[_i].isRequired = false;

    /*_i = this.enquiryForm.findIndex(x => x.field == 'testCategory');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.testCategory;
    this.enquiryForm[_i].text = this.translate.instant("grid." + this.enquiryToEdit.header!.testCategory); */

    _i = this.enquiryForm.findIndex(x => x.field == 'applicableNorms');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.applicableNorms!;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.applicableNorms!;

    _i = this.enquiryForm.findIndex(x => x.field == 'customerRequestDate');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.customerRequestDate ? this.enquiryToEdit.header!.customerRequestDate : ''; // this.datePipe.transform(this.enquiryToEdit.header!.dueDate!, this.dtFormat)!; 
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.customerRequestDate! ? this.enquiryToEdit.header!.customerRequestDate!.toString() : ''; //this.datePipe.transform(this.enquiryToEdit.header!.dueDate!, this.dtFormat)!; //


    // GBR 16/02/2024
    // MQF-98 - Se l'oggetto non è nella lista resetto valori e metto NormGrade a not valid
    _i = this.enquiryForm.findIndex(x => x.field == 'normGrades');
    let _newList: EnquiyNormGrade[] = new Array();
    let _clearRawMaterial: boolean = false;
    for (var t = 0; t < this.enquiryToEdit.header!.normGrades!.length; t++) {
      // TEMP TOREMOVE (for test the removing of a normgrade)
      //this.enquiryForm[_i].autoCompleteDataset! = this.enquiryForm[_i].autoCompleteDataset!.filter(x => x["normGradeId"] != 444);
      // 
      let _ngI: number = this.enquiryForm[_i].autoCompleteDataset!.findIndex(x => x["normGradeId"] == this.enquiryToEdit.header!.normGrades![t].normGradeId);
      if (_ngI == -1) {
        // Pulisco il dataset dell'oggetto che non esiste più
        this.enquiryForm[_i].autoCompleteDataset = this.enquiryForm[_i].autoCompleteDataset!.filter(x => x["normGradeId"] != this.enquiryToEdit.header!.normGrades![t].normGradeId!);
        _clearRawMaterial = true;
      } else {
        _newList.push(this.enquiryToEdit.header!.normGrades![t]);
      }
    }
    this.enquiryToEdit.header!.normGrades = _newList;
    _newList = new Array();

    if (this.enquiryToEdit.header!.normGrades) {
      this.enquiryForm[_i].value = this.enquiryToEdit.header!.normGrades!.map(x => x.normGradeId); //.join(',');
      this.enquiryForm[_i].text = this.enquiryToEdit.header!.normGrades!.map(x => x.normGradeCode); //.join(',');
    } else {
      this.enquiryForm[_i].value = "";
      this.enquiryForm[_i].text = "";
    }


    // GBR 16/02/2024
    // MQF-98 - Se l'oggetto non è nella lista resetto valori
    // Qui devo per forza fare una chiamata alla GetRawMaterialGrades per sapere se ho ancora questi Raw attivi
    // A questo punto se l'AutoCompleteDataset è vuoto (e dovrebbe avere una riga), vuol dire che l'oggetto è stato rimosso e devo svuotare i campi relativi
    _i = this.enquiryForm.findIndex(x => x.field == 'rawMaterialGrades');
    if (_i != -1 && !_clearRawMaterial) {
      this.enquiryForm[_i].value = this.enquiryToEdit.header!.rawMaterialGrade; // ? this.enquiryToEdit.header!.rawMaterialGrade!.rawMaterialGradeId : '';
      this.enquiryForm[_i].text = this.enquiryToEdit.header!.rawMaterialGrade; // ? this.enquiryToEdit.header!.rawMaterialGrade!.rawMaterialGradeCode : '';
      this.enquiryForm[_i].disabled = false;
      // MQF-403 - Non devo passare il valore, se no mi troca solo quello
      //this.getRawMaterialGrades(this.enquiryForm[_i].text, this.enquiryToEdit.header!.normGrades!.map(x => x.normGradeId!)!); 
      this.getRawMaterialGrades('', this.enquiryToEdit.header!.normGrades!.map(x => x.normGradeId!)!);
    } else {
      this.enquiryForm[_i].value = null;
      this.enquiryForm[_i].text = null;
      this.enquiryForm[_i].disabled = true;
    }
    /* this.getRawMaterialGrades(this.enquiryForm[_i].text, this.enquiryToEdit.header!.normGrades!.map(x => x.normGradeId!)!); */

    let _npsSchedule: boolean = (this.enquiryToEdit.header!.npsSchedule && this.enquiryToEdit.header!.npsSchedule.npsScheduleId) ? true : false;
    if (_npsSchedule) {
      _i = this.enquiryForm.findIndex(x => x.field == 'toolbarWtOdIdNps');
      this.enquiryForm[_i].toolbarButtonsList![0].state = '';
      this.enquiryForm[_i].toolbarButtonsList![1].state = 'pressed';
    }

    _i = this.enquiryForm.findIndex(x => x.field == 'od');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.od ? this.enquiryToEdit.header!.od : '';
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.od ? this.enquiryToEdit.header!.od!.toString() : '';
    if (_npsSchedule) this.enquiryForm[_i].readOnly = true;
    if (_npsSchedule) this.enquiryForm[_i].isRequired = false;


    _i = this.enquiryForm.findIndex(x => x.field == 'odUom');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.odUom ? this.enquiryToEdit.header!.odUom : odIdWtDefaultUom;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.odUom ? this.enquiryToEdit.header!.odUom : odIdWtDefaultUom;
    if (_npsSchedule) this.enquiryForm[_i].readOnly = true;
    if (_npsSchedule) this.enquiryForm[_i].isRequired = false;

    _i = this.enquiryForm.findIndex(x => x.field == 'id');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.id;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.id ? this.enquiryToEdit.header!.id!.toString() : '';
    if (_npsSchedule) this.enquiryForm[_i].disabled = true;
    if (_npsSchedule) this.enquiryForm[_i].isRequired = false;

    _i = this.enquiryForm.findIndex(x => x.field == 'idUom');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.idUom ? this.enquiryToEdit.header!.idUom : odIdWtDefaultUom;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.idUom ? this.enquiryToEdit.header!.idUom : odIdWtDefaultUom;
    if (_npsSchedule) this.enquiryForm[_i].disabled = true;
    if (_npsSchedule) this.enquiryForm[_i].isRequired = false;

    _i = this.enquiryForm.findIndex(x => x.field == 'wt');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.wt ? this.enquiryToEdit.header!.wt : '';
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.wt ? this.enquiryToEdit.header!.wt!.toString() : '';
    if (_npsSchedule) this.enquiryForm[_i].readOnly = true;
    if (_npsSchedule) this.enquiryForm[_i].isRequired = false;

    _i = this.enquiryForm.findIndex(x => x.field == 'wtUom');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.wtUom ? this.enquiryToEdit.header!.wtUom : odIdWtDefaultUom;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.wtUom ? this.enquiryToEdit.header!.wtUom : odIdWtDefaultUom;
    if (_npsSchedule) this.enquiryForm[_i].readOnly = true;
    if (_npsSchedule) this.enquiryForm[_i].isRequired = false;

    _i = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
    if (this.enquiryToEdit.header!.npsSchedule) {
      this.enquiryForm[_i].isRequired = true;
      // GBR 16/02/2024
      // MQF-98 - Se l'oggetto non è nella lista resetto valori
      _k = this.dataSetNps.findIndex(x => x["npsScheduleId"] == this.enquiryToEdit.header!.npsSchedule!.npsScheduleId!);
      if (_k != -1) {
        this.enquiryForm[_i].value = this.enquiryToEdit.header!.npsSchedule.npsScheduleId!;
        this.enquiryForm[_i].text = this.enquiryToEdit.header!.npsSchedule.npsDescription; // MQF-383
      } else {
        this.enquiryForm[_i].value = '';
        this.enquiryForm[_i].text = '';
        this.enquiryForm[_i].isValid = false;
        // DEVO ANCHE PULIRE OD/WT e relative Uoms
        _i = this.enquiryForm.findIndex(x => x.field == 'od');
        this.enquiryForm[_i].value = null;
        this.enquiryForm[_i].text = null;
        _i = this.enquiryForm.findIndex(x => x.field == 'odUom');
        this.enquiryForm[_i].value = null;
        this.enquiryForm[_i].text = null;
        _i = this.enquiryForm.findIndex(x => x.field == 'wt');
        this.enquiryForm[_i].value = null;
        this.enquiryForm[_i].text = null;
        _i = this.enquiryForm.findIndex(x => x.field == 'wtUom');
        this.enquiryForm[_i].value = null;
        this.enquiryForm[_i].text = null;
      }

    } else {
      this.enquiryForm[_i].value = '';
      this.enquiryForm[_i].text = '';
      this.enquiryForm[_i].isRequired = false;
    }

    _i = this.enquiryForm.findIndex(x => x.field == 'totalWeight');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.totalWeight !== null && this.enquiryToEdit.header!.totalWeight !== undefined ? this.enquiryToEdit.header!.totalWeight : ''; // MQF-212: It is ok to have totalweight equals to zero because is't a calcualted value
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.totalWeight !== null && this.enquiryToEdit.header!.totalWeight !== undefined ? this.enquiryToEdit.header!.totalWeight.toString() : '';
    if (!this.enquiryToEdit.header!.isTotalWeightEditable) this.enquiryForm[_i].disabled = true;

    _i = this.enquiryForm.findIndex(x => x.field == 'totalWeightUom');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.totalWeightUom ? this.enquiryToEdit.header!.totalWeightUom : '';
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.totalWeightUom ? this.enquiryToEdit.header!.totalWeightUom : '';

    _i = this.enquiryForm.findIndex(x => x.field == 'length');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.length ? this.enquiryToEdit.header!.length : '';
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.length ? this.enquiryToEdit.header!.length!.toString() : '';

    _i = this.enquiryForm.findIndex(x => x.field == 'lengthUom');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.lengthUom ? this.enquiryToEdit.header!.lengthUom : '';
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.lengthUom ? this.enquiryToEdit.header!.lengthUom : '';

    _i = this.enquiryForm.findIndex(x => x.field == 'remark');
    this.enquiryForm[_i].value = this.enquiryToEdit.header!.remark!;
    this.enquiryForm[_i].text = this.enquiryToEdit.header!.remark!;

    // GBR 16/02/2024
    // MQF-98 - Se l'oggetto non è nella lista resetto valori
    _i = this.enquiryForm.findIndex(x => x.field == 'marketFamily');
    _k = this.headerParametersValues.marketFamily!.findIndex(x => x.marketFamilyId == this.enquiryToEdit.header!.marketFamily!.marketFamilyId);
    if (_k != -1) {
      this.enquiryForm[_i].value = this.enquiryToEdit.header!.marketFamily!.marketFamilyId;
      this.enquiryForm[_i].text = this.enquiryToEdit.header!.marketFamily!.name;
    } else {
      this.enquiryForm[_i].value = null;
      this.enquiryForm[_i].text = null
      this.enquiryForm[_i].isValid = this.enquiryForm[_i].isRequired ? false : true;
    }

    _i = this.enquiryForm.findIndex(x => x.field == 'offerSchemeCode');
    if (_i != -1) {
      const offerSchemeCode = this.enquiryToEdit.header!.offerScheme?.offerSchemeCode ?? this.enquiryForm[_i].value ?? '';
      const offerSchemeOption = this.enquiryForm[_i].optionsList?.find(opt => opt.value == offerSchemeCode);
      this.enquiryForm[_i].value = offerSchemeCode;
      this.enquiryForm[_i].text = offerSchemeOption?.text ?? offerSchemeCode;
    }

    _i = this.enquiryForm.findIndex(x => x.field == 'bonusSchemeCode');
    if (_i != -1) {
      const bonusSchemeCode = this.enquiryToEdit.header!.bonusScheme?.bonusSchemeCode ?? this.enquiryForm[_i].value ?? '';
      const bonusSchemeOption = this.enquiryForm[_i].optionsList?.find(opt => opt.value == bonusSchemeCode);
      this.enquiryForm[_i].value = bonusSchemeCode;
      this.enquiryForm[_i].text = bonusSchemeOption?.text ?? bonusSchemeCode;
    }

    this.setRoundDigitsEnquiryForm();
    this.oldEnquiryForm = new Array();
    this.oldEnquiryForm = this.enquiryForm.filter(x => x.field != 'fake');// _.cloneDeep(this.enquiryForm);

    this.loadCustomerSpecialRequirements();
    this.showEditDialog = true;
  }

  getNormGrades(value: string) {
    // if (this.subsGetNormGrades != undefined) this.subsGetNormGrades.unsubscribe();
    this.subscriptions.add(this.backendService.getNormGrades([]).subscribe(res => {
      if (res && res.normGrades) {
        let _i: number = this.enquiryForm.findIndex(x => x.field == 'normGrades');
        this.enquiryForm[_i].autoCompleteDataset = new Array();
        this.enquiryForm[_i].autoCompleteDataset = [
          ...res.normGrades.filter(x => x.normGradeCode!.toLowerCase().startsWith(value.toLowerCase())).sort((a, b) => a.normGradeCode!.localeCompare(b.normGradeCode!)),
          ...res.normGrades.filter(x =>
            x.normGradeCode!.toLowerCase().includes(value!.toLowerCase()) &&
            !x.normGradeCode!.toLowerCase().startsWith(value!.toLowerCase())
          )
        ];
      }
    }));
  }

  // MQF-377
  getNormGradesObs(value: string): Promise<boolean> {
    // if (this.subsGetNormGrades != undefined) this.subsGetNormGrades.unsubscribe();
    return new Promise((resolve, reject) => {
      this.subscriptions.add(this.backendService.getNormGrades([]).subscribe(res => {
        if (res && res.normGrades) {
          let _i: number = this.enquiryForm.findIndex(x => x.field == 'normGrades');
          this.enquiryForm[_i].autoCompleteDataset = new Array();
          this.enquiryForm[_i].autoCompleteDataset = res.normGrades.filter(x => x.normGradeCode!.toLowerCase().includes(value.toLowerCase()));
          resolve(true);
        }
      }, err => {
        reject(err);
      }))
    });
  }

  /* ITEMS */
  fillDataSetItems() {
    let _tempList: any[] = new Array();
    this.dataSetItems = new Array();
    let _dataSet: GridDataset = new GridDataset();
    let _obj: EnquiryHeaderItem = new EnquiryHeaderItem();
    for (var i = 0; i < this.enquiryToEdit.items!.length; i++) {
      _dataSet = new GridDataset();
      _obj = new EnquiryHeaderItem();
      _obj = this.enquiryToEdit.items![i]!;
      for (const key in _obj) {
        let _value: any = _obj[key as keyof typeof _obj];
        if (_value == null) _value = "";
        let _typeOf: string = typeof _value;
        let _key: string = "";
        if (_typeOf != 'object') {
          _dataSet[key] = _value;
        } else {
          if (Array.isArray(_value)) {
            _key = key;
            if (_value.length == 0) {
              _dataSet[_key] = '';
            }
            if (_value.length > 0 && key.toLowerCase() == 'attachments') {
              _dataSet[_key] = _value.length;
            } else {
              for (const key2 in _value[0]) {
                _key = key + "." + key2;
                //_dataSet[key2] = _value.map(x => x[key2]).join(',');
                _dataSet[_key] = _value.map(x => x[key2]).join(',');
              }
            }
          } else {
            for (const key3 in _value) {
              if (typeof _value[key3] != 'object') {
                _key = key + "." + key3;
                let _value3: any = _value[key3 as keyof typeof _value];
                //_dataSet[key3] = _value3;
                _dataSet[_key] = _value3;
              } else {
                for (const key4 in _value[key3]) {
                  _key = key + "." + key3 + "." + key4;
                  let _value4: any = _value[key3][key4]; //_value[key4 as keyof typeof key4];
                  //_dataSet[key4] = _value4;
                  _dataSet[_key] = _value4;
                }
              }
            }
          }
        }
      }
      _tempList.push(_dataSet);
    }
    _tempList = _tempList.sort(
      function (a, b) {
        return a["itemNo"]! - b["itemNo"]!;
      }
    );

    this.dataSetItems = _tempList.filter(x => x["itemNo"] != 'TEIASOFT');
    _tempList = new Array();
    _dataSet = new GridDataset();
    _obj = new EnquiryHeaderItem();

    this.setRoundDigitsItemGrid();
  }

  hasEnquiryTotals(): boolean {
    return !!this.enquiryTotals;
  }

  private loadEnquiryTotals(): void {
    const enquiryNo = this.enquiryToEdit?.enquiryNo;
    if (!enquiryNo) {
      this.resetEnquiryTotals();
      return;
    }

    this.resetEnquiryTotals();
    this.subscriptions.add(this.backendService.getEnquiryTotalPriceAndMargin(enquiryNo).subscribe({
      next: res => {
        this.enquiryTotals = res;
        this.applyEnquiryTotalsFormatting();
      },
      error: () => {
        this.resetEnquiryTotals();
      }
    }));
  }

  private applyEnquiryTotalsFormatting(): void {
    if (!this.enquiryTotals) {
      this.resetEnquiryTotals();
      return;
    }

    const totalPrice = this.parseNumber(this.enquiryTotals.totalPrice);
    const totalMargin = this.parseNumber(this.enquiryTotals.totalMargin);
    const totalMarginPercentage = this.parseNumber(this.enquiryTotals.totalMarginPercentage);
    if (totalPrice == null || totalMargin == null || totalMarginPercentage == null) {
      this.resetEnquiryTotals();
      return;
    }

    const priceUom = this.getTotalsPriceUom();
    const priceSuffix = priceUom ? ` ${priceUom}` : '';
    const formattedPrice = this.formatNumber(totalPrice);
    const formattedMarginPercentage = this.formatNumber(totalMarginPercentage);
    const formattedMarginAmount = this.formatNumber(totalMargin);

    this.enquiryTotalPriceFormatted = `${formattedPrice}${priceSuffix}`;
    this.enquiryTotalMarginFormatted = `${formattedMarginPercentage}% / ${formattedMarginAmount}${priceSuffix}`;
    this.enquiryTotalMarginClass = this.getMarginClass(totalMargin);
  }

  private resetEnquiryTotals(): void {
    this.enquiryTotals = null;
    this.enquiryTotalPriceFormatted = '';
    this.enquiryTotalMarginFormatted = '';
    this.enquiryTotalMarginClass = '';
  }

  private getTotalsPriceUom(): string {
    const fromGrid = this.dataSetItems.find(item => !!item['totalPriceUom'])?.['totalPriceUom'];
    if (fromGrid) {
      return fromGrid;
    }

    const firstItem = this.enquiryToEdit?.items?.find(item => !!(item as any)['totalPriceUom']) as any;
    return firstItem?.totalPriceUom ?? '';
  }

  private parseNumber(value: string | number | null | undefined): number | null {
    if (value == null || value === '') {
      return null;
    }

    const parsed = typeof value === 'number'
      ? value
      : Number(value.toString().replace(/\s/g, '').replace(',', '.'));

    return Number.isFinite(parsed) ? parsed : null;
  }

  private formatNumber(value: number): string {
    return value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  private getMarginClass(totalMargin: number): string {
    if (totalMargin > 0) return 'green-text';
    if (totalMargin < 0) return 'red-text';
    return '';
  }

  buildCustomIconGrid() {
    this.customIcoCols = new Array();
    let _item: CustomIcoCol = new CustomIcoCol();
    _item.action = 'deleteItem';
    _item.icon = 'fal fa-trash-alt';
    _item.label = "deleteItem";
    this.customIcoCols.push(_item);

    _item = new CustomIcoCol();
    _item.action = "duplicateItem";
    _item.icon = 'fal fa-clone';
    _item.label = "duplicateItem";
    this.customIcoCols.push(_item);

    _item = new CustomIcoCol();
    _item.action = "editItem";
    _item.icon = 'fal fa-pencil-alt';
    _item.label = "editItem";
    this.customIcoCols.push(_item);
  }

  updateEnquiryItems(items: ItemToUpdate[], closeEditInPlaceOnSuccess: boolean = false) {
    this.teiasoftLoader.start();
    // if (this.subsUpdEnquiryItems != undefined) this.subsUpdEnquiryItems.unsubscribe();
    this.subscriptions.add(this.backendService.updateEnquiryItems(items, this.enquiryToEdit.enquiryNo!).subscribe({
      next: () => {
        if (closeEditInPlaceOnSuccess) {
          this.showEditInPlace = false;
        }
        this.reloadEnquiry.emit(this.enquiryToEdit.enquiryNo);
        this.teiasoftLoader.stop();
        this.items = [];
        this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      },
      error: () => {
        this.teiasoftLoader.stop();
      }
    }));
  }

  buildCalculatedCols() {
    this.calculatedCols = new Array();
    /* FEASIBILITY CALCULATED COL */
    let _item: CalculatedCols = new CalculatedCols();
    _item.id = 0;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|FeasibilityStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "F";
    this.calculatedCols.push(_item);

    /* PRICE CALCULATED COL */
    _item = new CalculatedCols();
    _item.id = 1;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|CostsStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "P";
    this.calculatedCols.push(_item);

    /* DELIVERY CALCULATED COL */
    _item = new CalculatedCols();
    _item.id = 2;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|DeliveryStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "D";
    this.calculatedCols.push(_item);

  }


  prepareItems(source: 'delete' | 'update', closeEditInPlaceOnSuccess: boolean = false) {
    const sourceItems = source === 'delete'
      ? this.enquiryToEdit.items?.filter((item) => item.itemNo != this.itemToDelete)
      : this.items;
    if (!sourceItems) return;

    const odIdWtUom = this.enquiryToEdit.header?.unitSystem == 'Metric' ? this.itemParameterValues.odUoms?.metricUoms?.find(u => u.isDefault)?.uomCode : this.itemParameterValues.odUoms?.imperialUoms?.find(u => u.isDefault)?.uomCode;
    const lengthUom = this.enquiryToEdit.header?.unitSystem == 'Metric' ? this.itemParameterValues.lengthUoms?.metricUoms?.find(u => u.isDefault)?.uomCode : this.itemParameterValues.lengthUoms?.imperialUoms?.find(u => u.isDefault)?.uomCode;


    const itemsToPrepare: ItemToUpdate[] = sourceItems.map((item, index) => {
      const preparedItem: ItemToUpdate = new ItemToUpdate();
      preparedItem.attachments = [...(item.attachments || [])];
      preparedItem.alloySurcharge = true;
      preparedItem.energySurcharge = item.energySurcharge;
      preparedItem.uBent = item.uBent;
      preparedItem.testCondition = item.testCondition;
      preparedItem.applicableNorms = item.applicableNorms || null;
      preparedItem.customerDeliveryDate = item.customerDeliveryDate || null;
      preparedItem.endsCondition = item.endsCondition;
      preparedItem.ht = item.ht!;
      preparedItem.htAdditional = item.htAdditional!;
      preparedItem.hydroTest = item.hydroTest;
      preparedItem.id = item.id ? parseFloat(item.id.toString()) : null;
      preparedItem.idUom = preparedItem.id != null ? odIdWtUom : null;
      preparedItem.idToleranceMinus = this.isFinite(item.idToleranceMinus)
        ? parseFloat(parseFloat(item.idToleranceMinus!.toString()).toFixed(this.getRoundDigits('toleranceMinus', index)))
        : undefined;
      preparedItem.idTolerancePlus = this.isFinite(item.idTolerancePlus)
        ? parseFloat(parseFloat(item.idTolerancePlus!.toString()).toFixed(this.getRoundDigits('tolerancePlus', index)))
        : undefined;
      preparedItem.idToleranceUom = this.areToleranceMeasuresFinite(preparedItem.idToleranceMinus, preparedItem.idTolerancePlus)
        ? item.idToleranceUom
        : undefined;
      preparedItem.inspectionType3dot2 = item.inspectionType3Dot2;
      preparedItem.itemNo = item.itemNo || null;
      preparedItem.customerItemNo = this.utils.normalizeCustomerItemNo(item.customerItemNo);
      preparedItem.lengthNominal = item.lengthNominal && item.lengthType === 'FL'
        ? parseFloat(item.lengthNominal.toString())
        : null;
      preparedItem.multipleLength = item.multipleLength!;
      preparedItem.lengthMax = Number.isFinite(item.lengthMax) ? parseFloat(item.lengthMax!.toString()) : undefined;
      preparedItem.lengthMin = Number.isFinite(item.lengthMin) ? parseFloat(item.lengthMin!.toString()) : undefined;
      preparedItem.lengthType = item.lengthType;
      preparedItem.lengthUom = lengthUom;
      preparedItem.marketFamilyId = item.marketFamily?.marketFamilyId;
      preparedItem.marketingGradeId = null;
      preparedItem.millId = item.mill?.millId;
      preparedItem.multipleCutting = item.multipleCutting;
      preparedItem.normGradesId = item.normGrades?.map((grade) => grade.normGradeId!) || [];
      preparedItem.gradeCustomerAnalysisLimitation = { ...item.gradeCustomerAnalysisLimitation };
      preparedItem.gradeCustomerOtherLimitation = { ...item.gradeCustomerOtherLimitation };
      preparedItem.npsScheduleId = item.npsSchedule?.npsScheduleId || null;
      preparedItem.od = item.od ? parseFloat(item.od.toString()) : null;
      preparedItem.odUom = preparedItem.od != null ? odIdWtUom : null;
      preparedItem.odToleranceMinus = this.isFinite(item.odToleranceMinus)
        ? parseFloat(parseFloat(item.odToleranceMinus!.toString()).toFixed(this.getRoundDigits('toleranceMinus', index)))
        : undefined;
      preparedItem.odTolerancePlus = this.isFinite(item.odTolerancePlus)
        ? parseFloat(parseFloat(item.odTolerancePlus!.toString()).toFixed(this.getRoundDigits('tolerancePlus', index)))
        : undefined;
      preparedItem.odToleranceUom = this.areToleranceMeasuresFinite(preparedItem.odToleranceMinus, preparedItem.odTolerancePlus)
        ? item.odToleranceUom
        : undefined;
      preparedItem.optionDate = item.optionDate!;
      preparedItem.quantity = parseFloat(item.quantity!.toString());
      preparedItem.quantityUom = item.quantityUom;
      preparedItem.rawMaterialGradeId = item.rawMaterialGrade?.rawMaterialGradeId || null;
      preparedItem.smsId = item.sms?.smsId;
      preparedItem.surfaceTypeId = item.surfaceType?.surfaceTypeId!;
      preparedItem.sqlId = item.sql?.sqlId ?? undefined;
      preparedItem.offerSchemeCode = item.offerScheme?.offerSchemeCode ?? null;
      preparedItem.remark = item.remark || null;
      preparedItem.totalWeightUom = item.totalWeightUom;
      preparedItem.typeOfTolerance = item.typeOfTolerance;
      preparedItem.tubeExecutionId = item.tubeExecution?.tubeExecutionId || undefined;
      preparedItem.wtToleranceMinus = this.isFinite(item.wtToleranceMinus)
        ? parseFloat(parseFloat(item.wtToleranceMinus!.toString()).toFixed(this.getRoundDigits('toleranceMinus', index)))
        : undefined;
      preparedItem.wtTolerancePlus = this.isFinite(item.wtTolerancePlus)
        ? parseFloat(parseFloat(item.wtTolerancePlus!.toString()).toFixed(this.getRoundDigits('tolerancePlus', index)))
        : undefined;
      preparedItem.wtToleranceUom = this.areToleranceMeasuresFinite(preparedItem.wtToleranceMinus, preparedItem.wtTolerancePlus)
        ? item.wtToleranceUom
        : undefined;
      preparedItem.unitSystem = item.unitSystem;
      preparedItem.ut = item.ut!;
      preparedItem.wt = item.wt ? parseFloat(item.wt.toString()) : null;
      preparedItem.wtUom = preparedItem.wt != null ? odIdWtUom : null;

      // delivery extra propeties
      preparedItem.cts = !!item.cts;
      preparedItem.dyePenetrant = !!item.dyePenetrant;
      preparedItem.dyePenetrant100P = !!item.dyePenetrant100P;
      preparedItem.penalty = !!item.penalty;
      preparedItem.colorCoding = !!item.colorCoding;
      preparedItem.specialOperations = !!item.specialOperations;
      preparedItem.specialTests = !!item.specialTests;
      preparedItem.grindingHoning = !!item.grindingHoning;
      preparedItem.ec = !!item.ec;
      preparedItem.notStdPackaging = !!item.notStdPackaging;

      // material code
      preparedItem.materialCode = item.material?.materialCode ?? null;

      if (source === 'update') {
        preparedItem.sourceItemNo = item.sourceItemNo; // Only for updates
      }

      preparedItem.remarks = item.remarks;
      preparedItem.isImportedFromAI = item.isImportedFromAI;

      return preparedItem;
    });

    this.updateEnquiryItems(itemsToPrepare, closeEditInPlaceOnSuccess);
  }

  isFinite(value: any): boolean {
    if (value == null)
      return false;

    return Number.isFinite(Number(value));
  }

  areToleranceMeasuresFinite(minus: number | undefined, plus: number | undefined): boolean {
    return Number.isFinite(minus) && Number.isFinite(plus);
  }


  getRoundDigits(col: string, selectedIndexItem: number): number {
    if (!this.roundDigitsForEditInPlace || this.roundDigitsForEditInPlace.length == 0) return 2;
    let _i: number = this.roundDigitsForEditInPlace.findIndex(x => x.fieldName?.toLowerCase() == col.toLowerCase());
    if (_i != -1) {
      if (this.items[selectedIndexItem].unitSystem == 'Metric') {
        return this.roundDigitsForEditInPlace[_i].metricDigits!;
      } else {
        return this.roundDigitsForEditInPlace[_i].imperialDigits!;
      }
    } else {
      return 2;
    }
  }

  onReloadEnquiry(enquiryNo: string) {
    this.showModalItem = false;
    this.items = [];
    this.reloadEnquiry.emit(enquiryNo);
  }

  getGridColumnConfiguration(configName: 'edit-in-place' | 'edit-in-place-costs'): DownloadGridColumn[] {
    const config = JSON.parse(this.globals.userLogged!.configuration!) as UserConfiguration;

    const gridConfig = config.gridsConfigurations?.find(gc => gc.name == configName);

    if (!gridConfig || !gridConfig.gridColumns)
      return this.generateDefaultGridColumnsConfig(configName);

    if (configName == 'edit-in-place') {
      return gridConfig.gridColumns.filter(gc => gc.visible).map(gc => {
        let dgc = new DownloadGridColumn();
        dgc.columnName = gc.name;
        dgc.columnLabel = this.translate.instant('grid.' + this.capitalizeFirstLetter(gc.name!));
        return dgc;
      });
    }
    if (configName == 'edit-in-place-costs') {
      return gridConfig.gridColumns.filter(gc => gc.visible).map(gc => {
        let dgc = new DownloadGridColumn();
        dgc.columnName = gc.name;
        dgc.columnLabel = this.translate.instant('grid.' + this.capitalizeFirstLetter(gc.name!));
        return dgc;
      });
    }

    throw new Error("invalid grid config name");

  }

  generateDefaultGridColumnsConfig(configName: 'edit-in-place' | 'edit-in-place-costs'): DownloadGridColumn[] {
    if (configName == 'edit-in-place')
      return this.columnsToShowItemEditInPlace.map(colName => {
        let dgc = new DownloadGridColumn();
        dgc.columnName = colName;
        dgc.columnLabel = this.translate.instant('grid.' + this.capitalizeFirstLetter(colName));
        return dgc;
      })
    if (configName == 'edit-in-place-costs')
      return this.itemPriceVisibleColumns.concat(this.itemCostsVisibileColumns).map(colName => {
        let dgc = new DownloadGridColumn();
        dgc.columnName = colName;
        dgc.columnLabel = this.translate.instant('grid.' + this.capitalizeFirstLetter(colName));
        return dgc;
      })
    return [];
  }

  capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  donwloadItems() {
    const columnsConfig = this.getGridColumnConfiguration('edit-in-place');
    this.teiasoftLoader.start();
    // if (this.subsDwnlItems != undefined) this.subsDwnlItems.unsubscribe();
    this.subscriptions.add(this.backendService.downloadItemsFile(this.enquiryToEdit.enquiryNo!, 'EditItems', columnsConfig).subscribe(res => {
      this.teiasoftLoader.stop();
      window.open(res["presignedUrl"], '_blank');
    }));
  }

  onDownloadItemsPrice(): void {
    const columnsConfig = this.getGridColumnConfiguration('edit-in-place-costs');
    const costsColumns = this.itemCostsVisibileColumns.map(gc => {
      let dgc = new DownloadGridColumn();
      dgc.columnName = gc;
      dgc.columnLabel = this.translate.instant('grid.' + this.capitalizeFirstLetter(gc));
      return dgc;
    });

    // Merge and deduplicate by columnName
    const mergedColumnsMap = new Map<string, DownloadGridColumn>();
    [...columnsConfig, ...costsColumns].forEach(col => {
      if (!mergedColumnsMap.has(col.columnName!)) {
        mergedColumnsMap.set(col.columnName!, col);
      }
    });
    const uniqueColumns = Array.from(mergedColumnsMap.values());

    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.downloadItemsFile(this.enquiryToEdit.enquiryNo!, 'EditPrices', uniqueColumns).subscribe(res => {
      this.teiasoftLoader.stop();
      window.open(res["presignedUrl"], '_blank');
    }));
  }

  uploadItems(base64: string) {
    this.teiasoftLoader.start();
    this.waitingEditInPlaceGridReady = true;
    // if (this.subsUplItems != undefined) this.subsUplItems.unsubscribe();
    this.subscriptions.add(this.backendService.uploadItemsFile(this.enquiryToEdit.enquiryNo!, base64).subscribe(res => {
      this.itemsToEdit = new Array();
      this.itemsFromXlsx = new ItemsFromXlsx();
      this.itemsFromXlsx = res;

      //this.dataSet = new Array();
      this.showEditInPlace = true;
    }, () => {
      this.waitingEditInPlaceGridReady = false;
      this.teiasoftLoader.stop();
    }));
  }

  onEditInPlaceGridReady(): void {
    if (!this.waitingEditInPlaceGridReady) {
      return;
    }

    this.waitingEditInPlaceGridReady = false;
    this.teiasoftLoader.stop();
  }

  uploadItemsPrice(base64: string) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.UploadItemsPricesFile(this.enquiryToEdit.enquiryNo!, base64).subscribe(res => {
      this.teiasoftLoader.stop();
      this.itemsPricesFromXlsx = res;
      this.applyImportedExtraLeadTimeToDeliveryDates(this.itemsPricesFromXlsx);
      this.showEditCosts = true;
    }));
  }

  private applyImportedExtraLeadTimeToDeliveryDates(importedPrices?: ItemsPricesFromXlsx): void {
    if (!importedPrices?.items || importedPrices.items.length === 0) {
      return;
    }

    importedPrices.items.forEach(importedItem => {
      const item = importedItem.item;
      if (!item) return;

      const hasExtraLeadTimeValue = item.extraLeadTime !== undefined && item.extraLeadTime !== null;
      if (!hasExtraLeadTimeValue) return;

      this.updateDeliveryDatesWithExtraLeadTime(item, item.extraLeadTime);
    });
  }


  onFileSelected(evt: any) {
    let _base64: string = "";
    let filereader = new FileReader();
    filereader.readAsDataURL(evt.target.files[0]);
    filereader.onload = (evt: any) => {
      _base64 = evt.target.result
        .replace('data:', '')
        .replace(/^.+,/, '');

      this.uploadItems(_base64);
      evt.target.value = null;
      $("#fileUpload").val(null);
    }
    _base64 = "";
  }

  onPriceFileSelected(evt: any) {
    let _base64: string = "";
    let filereader = new FileReader();
    filereader.readAsDataURL(evt.target.files[0]);
    filereader.onload = (evt: any) => {
      _base64 = evt.target.result
        .replace('data:', '')
        .replace(/^.+,/, '');

      this.uploadItemsPrice(_base64);
      evt.target.value = null;
      $("#filePriceUpload").val(null);
    }
    _base64 = "";
  }

  /* EVENTS */
  onDiscardClick() {
    this.teiasoftModalService.show('confirm', this.translate.instant("enquiryBook.discardEnquiry"), this.translate.instant("enquiryBook.confirmDiscardEnquiry"), this.enquiryToEdit.enquiryNo, 'confirmDiscardEnquiryEdit');
  }

  onSearchForSimilarEnquiries() {
    this.searchSimilarEnquiriesClick.emit(this.enquiryToEdit.enquiryNo);
  }

  onCloseEditingClick() {
    this.teiasoftModalService.show('confirm', this.translate.instant("enquiryBook.closeEditingSession"), this.translate.instant("enquiryBook.confirmCloseEditingSession"), this.enquiryToEdit.enquiryNo, 'confirmCloseEditingSession');
  }

  onReturnEnquiryBookClick() {
    this.returnEnquiryBookClick.emit('');
  }

  rowEditClick(evt: any) {

    if (this.priceEdited) {
      this.teiasoftToaster.show('info', this.translate.instant("commons.pendingChanges"))
      return;
    }


    this.dialogButtons = new Array();
    let _btn: DialogButton = new DialogButton();
    _btn.id = 0;
    _btn.action = 'addAttachment';
    _btn.buttonType = "tb-primary";
    _btn.text = this.translate.instant("commons.attachFile");
    _btn.disabled = false;
    this.dialogButtons.push(_btn);

    _btn = new DialogButton();
    _btn.id = 1;
    _btn.action = 'specialRequirements';
    _btn.buttonType = "tb-primary";
    _btn.text = this.translate.instant("enquiryBook.specialRequirements");
    _btn.disabled = false;
    this.dialogButtons.push(_btn);

    _btn = new DialogButton();
    _btn.id = 2;
    _btn.action = 'save';
    _btn.buttonType = "tb-secondary";
    _btn.text = this.translate.instant("commons.save");
    _btn.disabled = false;
    this.dialogButtons.push(_btn);

    _btn = new DialogButton();
    _btn.id = 3;
    _btn.action = 'cancel';
    _btn.buttonType = "tb-cancel";
    _btn.text = this.translate.instant("commons.cancel");
    _btn.disabled = false;
    this.dialogButtons.push(_btn);

    this.getHeaderParametersValues().then(() => {
      this.getNpsAndSchedules();
    });

    this.updateSpecialRequirementsButtonText();
  }

  private updateSpecialRequirementsButtonText(): void {
    const btn = this.dialogButtons.find(b => b.action === 'specialRequirements');
    if (!btn) {
      return;
    }
    const count = this.enquiryToEdit.header?.customerSpecialRequirements?.length ?? 0;
    btn.text = this.translate.instant("enquiryBook.specialRequirements");
    if (count > 0) {
      btn.text += ` (${count})`;
    }
  }

  setSelectUoms() {
    const fields = [
      { field: 'odUom', uomsKey: 'odUoms', labelField: 'od' },
      { field: 'idUom', uomsKey: 'idUoms', labelField: 'id' },
      { field: 'wtUom', uomsKey: 'wtUoms', labelField: 'wt' },
      { field: 'totalWeightUom', uomsKey: 'totalWeightUoms' },
    ];

    fields.forEach(({ field, uomsKey, labelField }) => {
      const index = this.enquiryForm.findIndex(x => x.field === field);
      if (index === -1) return;

      const formField = this.enquiryForm[index];
      formField.value = '';
      formField.text = '';
      formField.optionsList = this.getUoms(uomsKey) || [];

      if (!formField.disabled && formField.optionsList.length > 0) {
        const defaultOption = formField.optionsList.find(option => option.isDefault);
        formField.value = defaultOption ? defaultOption.value : '';
      }

      // Update label field
      const labelIndex = this.enquiryForm.findIndex(x => x.field === labelField);
      if (labelIndex !== -1) {
        const labelFieldEntry = this.enquiryForm[labelIndex];
        labelFieldEntry.labelText = labelFieldEntry.labelText!.replace(/\s*\(.*?\)$/, '');
        labelFieldEntry.labelText = labelFieldEntry.labelText + (formField.value ? ` (${formField.value})` : '')
      }
    });
  }

  getUoms(uom: string): SelectOption[] {
    let _list: SelectOption[] = new Array();
    let _i: number = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
    let _unitSystem: string = "";
    if (_i != -1) {
      _unitSystem = this.enquiryForm[_i].value!;
      if (_unitSystem != '') {
        for (const prop in this.headerParametersValues) {
          if (prop.toString() == uom) {
            let _uoms: UomsType = new UomsType();
            _uoms = this.headerParametersValues[prop as keyof HeaderParametersValues] as UomsType;
            if (_unitSystem.toLowerCase() == 'metric') {
              for (var x = 0; x < _uoms.metricUoms!.length; x++) {
                let _item: SelectOption = new SelectOption();
                _item.text = _uoms.metricUoms![x].uomCode!;
                _item.value = _uoms.metricUoms![x].uomCode!;
                _item.isDefault = _uoms.metricUoms![x].isDefault;
                _list.push(_item);
              }
            } else {
              for (var x = 0; x < _uoms.imperialUoms!.length; x++) {
                let _item: SelectOption = new SelectOption();
                _item.text = _uoms.imperialUoms![x].uomCode!;
                _item.value = _uoms.imperialUoms![x].uomCode!;
                _item.isDefault = _uoms.imperialUoms![x].isDefault;
                _list.push(_item);
              }
            }
          }
        }
        // Se ho settato gli NPS devo modificare i valori delle OD/WT
        _i = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
        if (this.enquiryForm[_i].value != '' && this.enquiryForm[_i].value != null) {
          let _npsId = parseInt(this.enquiryForm[_i].value);
          if (this.dataSetNps && this.dataSetNps.length > 0) {
            if (_unitSystem.toLowerCase() == 'metric') {
              _i = this.enquiryForm.findIndex(x => x.field == 'od');
              this.enquiryForm[_i].value = this.dataSetNps.filter(x => parseInt(x["npsScheduleId"]) == _npsId)[0]["odMetric"];
              this.enquiryForm[_i].text = this.enquiryForm[_i].value;

              _i = this.enquiryForm.findIndex(x => x.field == 'wt');
              this.enquiryForm[_i].value = this.dataSetNps.filter(x => parseInt(x["npsScheduleId"]) == _npsId)[0]["wtMetric"];
              this.enquiryForm[_i].text = this.enquiryForm[_i].value;
            } else {
              _i = this.enquiryForm.findIndex(x => x.field == 'od');
              this.enquiryForm[_i].value = this.dataSetNps.filter(x => parseInt(x["npsScheduleId"]) == _npsId)[0]["odImperial"];
              this.enquiryForm[_i].text = this.enquiryForm[_i].value;

              _i = this.enquiryForm.findIndex(x => x.field == 'wt');
              this.enquiryForm[_i].value = this.dataSetNps.filter(x => parseInt(x["npsScheduleId"]) == _npsId)[0]["wtImperial"];
              this.enquiryForm[_i].text = this.enquiryForm[_i].value;
            }
          }
        }

      }



    }

    return _list;
  }

  getCustomers() {
    this.dataSetCustomers = new Array();
    this.dataSetCustomers = this.headerParametersValues.customers!;
    this.showSelectCustomer = true;
  }

  getRawMaterialGrades_old(value: string, normGradeIds: number[]) {
    // if (this.subsGetRawMaterial != undefined) this.subsGetRawMaterial.unsubscribe();
    this.subscriptions.add(this.backendService.getRawMaterialGrades(normGradeIds).subscribe(res => {
      if (res && res.rawMaterialGrades) {
        /* TEMP */
        //res.rawMaterialGrades! = res.rawMaterialGrades!.filter(x => x.rawMaterialGradeCode != 'DMV304LMC');
        let _i: number = this.enquiryForm.findIndex(x => x.field == 'rawMaterialGrades');
        if (res.rawMaterialGrades.length > 0) {
          this.enquiryForm[_i].autoCompleteDataset = new Array();
          if (value != null)
            this.enquiryForm[_i].autoCompleteDataset = res.rawMaterialGrades.filter(x => x.rawMaterialGradeCode!.toLowerCase().includes(value.toLowerCase()));
          else
            this.enquiryForm[_i].autoCompleteDataset = res.rawMaterialGrades;

          this.enquiryForm[_i].disabled = false;

          const autoSelectedGrade = this.getSingleAutoSelectableRawMaterialGrade(this.enquiryForm[_i].autoCompleteDataset as RawMaterialGrade[]);
          if (autoSelectedGrade) {
            this.enquiryForm[_i].value = autoSelectedGrade.rawMaterialGradeId;
            this.enquiryForm[_i].text = autoSelectedGrade.rawMaterialGradeCode;
          }

          // MQF-98 - Ora devo controllare che la mia RawMaterialGrade sia in lista
          let _iRmG: number = this.enquiryForm[_i].autoCompleteDataset!.findIndex(x => x.rawMaterialGradeId == this.enquiryForm[_i].value);
          if (_iRmG == -1) {
            this.enquiryForm[_i].disabled = true;
            this.enquiryForm[_i].value = null;
            this.enquiryForm[_i].text = null;
          }
        } else {
          this.enquiryForm[_i].disabled = true;
          this.enquiryForm[_i].value = null;
          this.enquiryForm[_i].text = null;
          //this.teiasoftToaster.show("info", this.translate.instant("enquiryBook.noRawMaterials"));
        }

      }
    }));
  }

  getLimitationsForNormGrades(normGradeIds: number[]) {
    this.subscriptions.add(this.backendService.getLimitationsForNormGrades(normGradeIds).subscribe(res => {
      this.limitationsForNormGrades = new LimitationsForNormGrades();
      this.limitationsForNormGrades = res;
    }));
  }

  getRawMaterialGrades(value: string, normGradeIds: number[]) {

    this.subscriptions.add(this.backendService.getRawMaterialGradesForEnquiry(normGradeIds).subscribe(res => {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'rawMaterialGrades');
      console.log("RES RAW MATERIAL GRADES FOR " + value, res);
      if (res && res.rawMaterialGrades!.length > 0) {

        this.enquiryForm[_i].disabled = false;
        this.enquiryForm[_i].autoCompleteDataset = new Array();
        let rawMaterialGrades = res.rawMaterialGrades;
        if (value != '' && value != null) {
          rawMaterialGrades = rawMaterialGrades!.filter(x => x.toLowerCase().includes(value.toLowerCase()));
        }
        for (var x = 0; x < rawMaterialGrades!.length; x++) {
          let _item: RawMaterialGrade = new RawMaterialGrade();
          _item.rawMaterialGradeCode = rawMaterialGrades![x];
          _item.rawMaterialGradeId = x;
          _item.isDefault = false;
          this.enquiryForm[_i].autoCompleteDataset!.push(_item);
        }

        if (this.enquiryForm[_i].autoCompleteDataset!.length == 1) {
          this.enquiryForm[_i].value = this.enquiryForm[_i].autoCompleteDataset![0]["rawMaterialGradeId"];
          this.enquiryForm[_i].text = this.enquiryForm[_i].autoCompleteDataset![0]["rawMaterialGradeCode"];
        }

        // MQF-98 - Ora devo controllare che la mia RawMaterialGrade sia in lista
        if (this.enquiryForm[_i].text != null && this.enquiryForm[_i].text != '') {
          let _iRmG: number = this.enquiryForm[_i].autoCompleteDataset!.findIndex(x => x["rawMaterialGradeCode"] == this.enquiryForm[_i].text);
          if (_iRmG == -1) {
            this.enquiryForm[_i].disabled = true;
            this.enquiryForm[_i].value = null;
            this.enquiryForm[_i].text = null;
          }
        }

        // MQF-401
        this.enquiryForm[_i].isRequired = true;

      } else {
        this.enquiryForm[_i].disabled = true;
        this.enquiryForm[_i].value = null;
        this.enquiryForm[_i].text = null;
        // MQF-401
        this.enquiryForm[_i].isRequired = false;
      }
    }));
  }

  checkTTButtonsCustomer(action: string) {
    let _i: number = this.enquiryForm.findIndex(x => x.field == 'toolbarCustomer');
    for (var x = 0; x < this.enquiryForm[_i].toolbarButtonsList!.length; x++) {
      if (action == 'savedCustomer' || action == 'savedDummy') {
        this.enquiryForm[_i].toolbarButtonsList![0].disabled = action == 'savedCustomer' ? false : true;
        this.enquiryForm[_i].toolbarButtonsList![1].disabled = true;
        this.enquiryForm[_i].toolbarButtonsList![2].disabled = action == 'savedCustomer' ? true : false;
        this.enquiryForm[_i].toolbarButtonsList![3].disabled = false;
      }

      if (action == 'clearCustomer') {
        this.enquiryForm[_i].toolbarButtonsList![0].disabled = false;
        this.enquiryForm[_i].toolbarButtonsList![1].disabled = false;
        this.enquiryForm[_i].toolbarButtonsList![2].disabled = true;
        this.enquiryForm[_i].toolbarButtonsList![3].disabled = true;
      }
    }
  }

  setWtOdIdNps(show: string, cancelValue: boolean) {
    let _i: number = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
    let _nps: boolean = this.enquiryForm![_i].value != '';
    if (show == 'nps') {
      // Turn OFF 
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'od');
      this.enquiryForm[_i].isRequired = false;
      this.enquiryForm[_i].value = _nps ? this.enquiryToEdit.header!['od'] : '';
      this.enquiryForm[_i].text = _nps ? this.enquiryToEdit.header!['od'] : '';
      this.enquiryForm[_i].readOnly = true;

      _i = this.enquiryForm.findIndex(x => x.field == 'odUom');
      this.enquiryForm[_i].isRequired = false;
      this.enquiryForm[_i].value = _nps ? this.enquiryToEdit.header!['odUom'] : '';
      this.enquiryForm[_i].text = _nps ? this.enquiryToEdit.header!['odUom'] : '';
      this.enquiryForm[_i].readOnly = true;

      _i = this.enquiryForm.findIndex(x => x.field == 'id');
      this.enquiryForm[_i].disabled = true;
      this.enquiryForm[_i].isRequired = false;
      this.enquiryForm[_i].value = _nps ? this.enquiryToEdit.header!['id'] : '';
      this.enquiryForm[_i].text = _nps ? this.enquiryToEdit.header!['id'] : '';

      _i = this.enquiryForm.findIndex(x => x.field == 'idUom');
      this.enquiryForm[_i].disabled = true;
      this.enquiryForm[_i].isRequired = false;
      this.enquiryForm[_i].value = _nps ? this.enquiryToEdit.header!['idUom'] : '';
      this.enquiryForm[_i].text = _nps ? this.enquiryToEdit.header!['idUom'] : '';

      _i = this.enquiryForm.findIndex(x => x.field == 'wt');
      this.enquiryForm[_i].isRequired = false;
      this.enquiryForm[_i].value = _nps ? this.enquiryToEdit.header!['wt'] : '';
      this.enquiryForm[_i].text = _nps ? this.enquiryToEdit.header!['wt'] : '';
      this.enquiryForm[_i].readOnly = true;

      _i = this.enquiryForm.findIndex(x => x.field == 'wtUom');
      this.enquiryForm[_i].isRequired = false;
      this.enquiryForm[_i].value = _nps ? this.enquiryToEdit.header!['wtUom'] : '';
      this.enquiryForm[_i].text = _nps ? this.enquiryToEdit.header!['wtUom'] : '';
      this.enquiryForm[_i].readOnly = true;

      // Turn ON
      _i = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
      this.enquiryForm[_i].disabled = false;
      this.enquiryForm[_i].isRequired = true;
      this.enquiryForm[_i].value = _nps ? (this.enquiryToEdit.header!['npsSchedule']! ? this.enquiryToEdit.header!['npsSchedule']!["npsScheduleId"] : '') : '';
      this.enquiryForm[_i].text = _nps ? (this.enquiryToEdit.header!['npsSchedule']! ? this.enquiryToEdit.header!['npsSchedule']!["npsDescription"] : '') : '';

    } else {
      // Turn ON 
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'od');
      this.enquiryForm[_i].isRequired = true;
      this.enquiryForm[_i].value = cancelValue ? '' : this.enquiryForm[_i].value;
      this.enquiryForm[_i].text = cancelValue ? '' : this.enquiryForm[_i].value;
      this.enquiryForm[_i].readOnly = false;

      _i = this.enquiryForm.findIndex(x => x.field == 'odUom');
      this.enquiryForm[_i].isRequired = true;
      /* this.enquiryForm[_i].value = '';
      this.enquiryForm[_i].text = ''; */
      this.enquiryForm[_i].value = this.enquiryForm[_i].optionsList!.length > 0 ? this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].value! : '';
      this.enquiryForm[_i].text = this.enquiryForm[_i].optionsList!.length > 0 ? this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].text! : '';
      this.enquiryForm[_i].readOnly = false;

      _i = this.enquiryForm.findIndex(x => x.field == 'id');
      this.enquiryForm[_i].disabled = false;
      this.enquiryForm[_i].isRequired = true;
      this.enquiryForm[_i].value = cancelValue ? '' : this.enquiryForm[_i].value;
      this.enquiryForm[_i].text = cancelValue ? '' : this.enquiryForm[_i].value;

      _i = this.enquiryForm.findIndex(x => x.field == 'idUom');
      this.enquiryForm[_i].disabled = false;
      this.enquiryForm[_i].isRequired = true;
      /* this.enquiryForm[_i].value = '';
      this.enquiryForm[_i].text = ''; */
      this.enquiryForm[_i].value = this.enquiryForm[_i].optionsList!.length > 0 ? this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].value! : '';
      this.enquiryForm[_i].text = this.enquiryForm[_i].optionsList!.length > 0 ? this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].text! : '';

      _i = this.enquiryForm.findIndex(x => x.field == 'wt');
      this.enquiryForm[_i].isRequired = true;
      this.enquiryForm[_i].value = cancelValue ? '' : this.enquiryForm[_i].value;
      this.enquiryForm[_i].text = cancelValue ? '' : this.enquiryForm[_i].value;
      this.enquiryForm[_i].readOnly = false;

      _i = this.enquiryForm.findIndex(x => x.field == 'wtUom');
      this.enquiryForm[_i].isRequired = true;
      /*     this.enquiryForm[_i].value = '';
          this.enquiryForm[_i].text = ''; */
      this.enquiryForm[_i].value = this.enquiryForm[_i].optionsList!.length > 0 ? this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)[0].value! : '';
      this.enquiryForm[_i].text = this.enquiryForm[_i].optionsList!.length > 0 ? this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].text! : '';
      this.enquiryForm[_i].readOnly = false;

      // Turn OFF
      _i = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
      this.enquiryForm[_i].disabled = true;
      this.enquiryForm[_i].isRequired = false;
      this.enquiryForm[_i].value = '';
      this.enquiryForm[_i].text = '';
    }
  }

  getNpsAndSchedules() {
    this.teiasoftLoader.start();
    // if (this.subsGetNps != undefined) this.subsGetNps.unsubscribe();
    this.subscriptions.add(this.backendService.getNpsAndSchedules().subscribe(res => {
      this.teiasoftLoader.stop();
      this.dataSetNps = new Array();
      if (res) {
        this.dataSetNps = this.utils.sortNpSAndSchedule(res.npsSchedules!); // MQF-150
        for (var x = 0; x < this.dataSetNps.length; x++) {
          let obj: any = this.dataSetNps[x];
          for (const key in obj) {
            if (typeof obj[key] == 'number') {
              if (key.toLowerCase() != 'npsscheduleid') {
                let _digits: number = 2;
                let _col: string = key.substring(0, 2);
                if (key.indexOf("Metric") != -1 && this.roundDigitsForEnquiryForm!.filter(x => x.fieldName == _col)[0]) {
                  _digits = this.roundDigitsForEnquiryForm!.filter(r => r.fieldName == _col)[0].metricDigits!;
                }
                if (key.indexOf("Imperial") != -1 && this.roundDigitsForEnquiryForm!.filter(x => x.fieldName == _col)[0]) {
                  _digits = this.roundDigitsForEnquiryForm!.filter(r => r.fieldName == _col)[0].imperialDigits!;
                }
                this.dataSetNps[x][key] = this.dataSetNps[x][key].toFixed(_digits); // Number(this.dataSetNps[x][key].toFixed(4));
              }
            }
          }

          // Adding Uoms
          let _metricUom: string = "metricUom";
          this.dataSetNps[x][_metricUom as string] = 'mm';

          let _imperialUom: string = "imperialUom";
          this.dataSetNps[x][_imperialUom as string] = 'in';
        }

        this.getNormGradesObs('').then(() => { this.fillFormEdit(); }); // MQF-377
      }
    }));
  }

  editEnquiry(enquiryToEdit: EditEnquiry, attachmentsToUpdate: AttachmentToUpdate[], attachmentsToDelete: EnquiryAttachmentToDelete[]) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.editEnquiry(enquiryToEdit, this.enquiryToEdit.enquiryNo!).subscribe(res => {
      if ((!attachmentsToUpdate || attachmentsToUpdate.length == 0) && (!attachmentsToDelete || attachmentsToDelete.length == 0)) {
        this.teiasoftLoader.stop();
        this.showEditDialog = false;
        this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
        this.reloadEnquiry.emit(this.enquiryToEdit.enquiryNo);
        return;
      } else {
        this.uploadEnquiryAttachments(this.enquiryToEdit.enquiryNo!, attachmentsToUpdate!, attachmentsToDelete);
      }
    }));
  }

  uploadEnquiryAttachments(enquiryNo: string, attachmentsToUpdate: AttachmentToUpdate[], attachmentsToDelete: EnquiryAttachmentToDelete[]) {
    if (attachmentsToUpdate && attachmentsToUpdate.length > 0) {
      this.subscriptions.add(this.backendService.uploadEnquiryAttachment(enquiryNo, attachmentsToUpdate).subscribe(res => {
        if (!attachmentsToDelete || attachmentsToDelete.length == 0) {
          this.teiasoftLoader.stop();
          this.showEditDialog = false;
          this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
          this.reloadEnquiry.emit(this.enquiryToEdit.enquiryNo);
        } else {
          this.deleteEnquiryAttachment(this.enquiryToEdit.enquiryNo!, attachmentsToDelete);
        }
      }));
    } else {
      this.deleteEnquiryAttachment(this.enquiryToEdit.enquiryNo!, attachmentsToDelete);
    }

  }

  deleteEnquiryAttachment(enquiryNo: string, attachmentsToDelete: EnquiryAttachmentToDelete[]) {
    let _ids: number[] = new Array();
    _ids = attachmentsToDelete.map(x => x.fileId!);
    this.subscriptions.add(this.backendService.deleteEnquiryAttachment(enquiryNo, _ids).subscribe(res => {
      this.teiasoftLoader.stop();
      this.showEditDialog = false;
      this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      this.reloadEnquiry.emit(this.enquiryToEdit.enquiryNo);
    }));
  }

  customIconClick(evt: any) {

    if (this.priceEdited) {
      this.teiasoftToaster.show('info', this.translate.instant("commons.pendingChanges"))
      return;
    }

    const { action: _action, row: _obj } = parseGridActionEvent(evt);
    if (_action == 'deleteItem') {
      let _param: string = _obj["itemNo"] + " " + this.enquiryToEdit.enquiryNo;
      let _message: string = this.translate.instant("enquiryBook.confirmDeleteItem").replace("{0}", _obj["customerItemNo"]).replace("{1}", this.enquiryToEdit.enquiryNo);
      this.teiasoftModalService.show('confirm', this.translate.instant("grid.deleteItem"), _message, _param, 'confirmDeleteItem');
    } else if (_action == 'duplicateItem') {
      this.items = new Array();
      this.items = this.enquiryToEdit.items!.filter(x => x.itemNo != 'TEIASOFT');
      let _sel: number = this.enquiryToEdit.items!.findIndex(x => x.itemNo == _obj["itemNo"]);
      let _item: EnquiryHeaderItem = new EnquiryHeaderItem();
      _item = JSON.parse(JSON.stringify(this.enquiryToEdit.items![_sel])); // _.cloneDeep(this.enquiryToEdit.items![_sel]);
      _item.itemNo = undefined;
      _item.sourceItemNo = this.enquiryToEdit.items![_sel].itemNo;
      this.items.push(_item);
      _item = new EnquiryHeaderItem();
      this.items[this.items.length - 1].itemNo = undefined;
      this.items[this.items.length - 1].customerItemNo = this.calculateNextCustomerItemNo(this.items);
      this.items[this.items.length - 1].attachments = []; // MQF-121
      this.itemAction = 'duplicate';
      this.selectedIndexItem = this.items.length - 1;
      this.getHeaderParametersValues().then(() => { this.showModalItem = true; })
    } else {
      // Edit Item
      this.items = new Array();
      this.items = this.enquiryToEdit.items!.filter(x => x.itemNo != 'TEIASOFT');;
      this.itemAction = 'edit';
      this.selectedIndexItem = this.enquiryToEdit.items!.findIndex(x => x.itemNo! == _obj["itemNo"]);
      this.getHeaderParametersValues().then(() => { this.showModalItem = true; })
    }
  }

  customIconContextMenuClick(evt: any) {
    const { col, row } = evt;

    if (!col || !row) return;

    if (this.priceEdited) {
      this.teiasoftToaster.show('info', this.translate.instant("commons.pendingChanges"));
      return;
    }

    if (this.tryOpenItdcrHistoryFromStatusContextMenu(col, row)) {
      return;
    }

    if (col == 'costsStatus') {
      this.showCostingToolModal = true;
      this.costingToolItem = row;
    }
  }

  private getStatusSourceValue(row: any, sourceColumn: 'feasibilitySource' | 'costsSource' | 'deliverySource'): string {
    return String(row?.[sourceColumn] ?? '').trim().toLowerCase();
  }

  private isItdcrOrItrSource(row: any, sourceColumn: 'feasibilitySource' | 'costsSource' | 'deliverySource'): boolean {
    const source = this.getStatusSourceValue(row, sourceColumn);
    return source === 'itdcr' || source === 'itr';
  }

  private tryOpenItdcrHistoryFromStatusContextMenu(col: string, row: any): boolean {
    const sourceColumnByStatus: Record<string, 'feasibilitySource' | 'costsSource' | 'deliverySource'> = {
      feasibilityStatus: 'feasibilitySource',
      costsStatus: 'costsSource',
      deliveryStatus: 'deliverySource'
    };
    const categoryByStatus: Record<string, 'F' | 'P' | 'D'> = {
      feasibilityStatus: 'F',
      costsStatus: 'P',
      deliveryStatus: 'D'
    };

    const sourceColumn = sourceColumnByStatus[col];
    const category = categoryByStatus[col];
    if (!sourceColumn || !category) return false;

    if (!this.isItdcrOrItrSource(row, sourceColumn)) return false;

    const enquiryNo = this.enquiryToEdit?.enquiryNo;
    const itemNo = row['itemNo'];
    if (!enquiryNo || itemNo == null || itemNo === '') return true;

    this.teiasoftLoader.start();
    this.subscriptions.add(
      this.backendService.getItdcrNumberByItemAndCategory(enquiryNo, String(itemNo), category)
        .pipe(finalize(() => this.teiasoftLoader.stop()))
        .subscribe(res => {
          const itdcrNo = res?.itdcrNo?.trim?.() || '';
          if (!itdcrNo) {
            this.teiasoftToaster.show("info", this.translate.instant("itdcr.notAvailableForItem"));
            return;
          }

          this.itdcrViewerNo = itdcrNo;
          this.itdcrViewerShowHistory = true;
          this.showItdcrViewerModal = true;
        })
    );

    return true;
  }

  async onAddItemClick() {
    this.items = new Array();
    this.items = Object.assign(this.items, this.enquiryToEdit.items!);
    this.itemAction = 'create';
    let _item: EnquiryHeaderItem = new EnquiryHeaderItem();
    await this.setDefaultValuesForNewItem(_item, true);
    this.items.push(_item);
    this.selectedIndexItem = this.items.length - 1;

    if (this.items.length > 1) {
      this.items[this.selectedIndexItem] = cloneDeep(this.items[this.selectedIndexItem - 1])
      this.items[this.selectedIndexItem].itemNo = null;
      this.items[this.selectedIndexItem].attachments = undefined;
    }
    this.items[this.selectedIndexItem].customerItemNo = this.calculateNextCustomerItemNo(this.items);
    this.showModalItem = true;
  }

  onAddItemFromIAClick() {
    this.showUploadFromAI = true;
  }

  calculateNextCustomerItemNo(items: EnquiryHeaderItem[]): string {
    if (items.length === 1) {
      return '001';  // First item in the list
    }

    let allNumeric = true;
    let maxCustomerItemNo = 0;
    let maxCustomerItemNoRaw = '';

    for (const item of items) {
      const parsedCustomerItemNo = parseInt(item.customerItemNo!, 10);

      if (isNaN(parsedCustomerItemNo)) {
        allNumeric = false;
      } else {
        if (parsedCustomerItemNo > maxCustomerItemNo) {
          maxCustomerItemNo = parsedCustomerItemNo;
          maxCustomerItemNoRaw = item.customerItemNo!;
        }
      }
    }

    if (allNumeric) {
      // Determine next number based on previous format
      const nextCustomerItemNo = (maxCustomerItemNo + 1).toString();
      const paddingLength = maxCustomerItemNoRaw.length;

      // Add padding only if it was present
      return nextCustomerItemNo.padStart(paddingLength, '0');
    } else {
      // Fallback to itemNo + 1
      const nextItemNo = parseInt(this.items[this.items.length - 1].itemNo!, 10) + 1;
      if (isNaN(nextItemNo)) {
        return '';
      }
      return nextItemNo.toString();
    }
  }



  onDownloadItemsClick() {
    this.donwloadItems();
  }

  onDownloadItemsPriceClick() {
    this.onDownloadItemsPrice();
  }

  onUploadItemsClick() {
    $("#fileUpload").click();
  }

  onUploadItemsPriceClick() {
    $("#filePriceUpload").click();
  }

  closeModalItem(evt: any) {
    if (evt == 'create') {
      this.items = [];
    }
    this.showModalItem = false;
  }

  /* EDIT IN PLACE */
  changedEditInPlace(items: EnquiryHeaderItem[]) {
    this.items = new Array();
    this.items = items;
    this.prepareItems('update', true);
  }

  // To be deprecated? this should be covered by changedEditInPlace
  deleteItemsEditInPlace(itemsNo: string[]) {
    for (var x = 0; x < itemsNo.length; x++) {
      this.enquiryToEdit.items = this.enquiryToEdit.items!.filter(i => i.itemNo != itemsNo[x]);
    }
    this.prepareItems('update', true);
  }

  closeEditInPlace() {
    // Verifico se ho un solo Item e quell'item ha ItemoNo a null, che significa che ho aperto EditInPlace e poi ho deciso di chiudere senza salvare
    if (this.enquiryToEdit.items && this.enquiryToEdit.items!.length == 1 && this.enquiryToEdit.items![0].itemNo == null) this.enquiryToEdit.items! = new Array();
    if (this.waitingEditInPlaceGridReady) {
      this.waitingEditInPlaceGridReady = false;
      this.teiasoftLoader.stop();
    }
    this.showEditInPlace = false
  }

  onEditInPlaceClick() {
    this.itemsFromXlsx = undefined;
    // GBR 05/05/2024 - Significa che è il promi Item che creo.
    // A questo punto ne creo uno vuoto
    if (!this.enquiryToEdit.items || this.enquiryToEdit.items!.length == 0) {
      this.createItemFromEnquiry();
    } else {
      this.itemsToEdit = new Array();
      this.itemsToEdit = JSON.parse(JSON.stringify(this.enquiryToEdit.items!));
      this.itemsToEdit = this.itemsToEdit.map(this.sortItemProperties);
      this.showEditInPlace = true;
    }
  }

  sortItemProperties(item: EnquiryHeaderItem): any {
    const propertyOrder = ['itemNo',
      'customerItemNo', 'material', 'alloySurcharge', 'energySurcharge', 'applicableNorms', 'remark', 'normGrades',
      'marketingGrade', 'gradeCustomerAnalysisLimitation', 'gradeCustomerOtherLimitation',
      'rawMaterialGrade', 'unitSystem', 'quantity', 'quantityUom', 'npsSchedule', 'od', 'odUom', 'odTolerancePlus', 'odToleranceMinus',
      'odToleranceUom',
      'id', 'idUom', 'idTolerancePlus', 'idToleranceMinus',
      'idToleranceUom', 'wt', 'wtUom', 'typeOfTolerance', 'tubeExecution',
      'wtTolerancePlus', 'wtToleranceMinus', 'wtToleranceUom', 'lengthType', 'multipleLength', 'lengthMin', 'lengthMax',
      'lengthNominal', 'lengthUom', 'marketingRoute', 'sms', 'marketFamily', 'cts', 'endsCondition', 'testCondition', 'sql', 'offerScheme', 'ut',
      'hydroTest', 'ht', 'htAdditional', 'dyePenetrant', 'dyePenetrant100P', 'penalty', 'colorCoding', 'specialOperations', 'specialTests', 'grindingHoning', 'ec', 'notStdPackaging', 'inspectionType3Dot2', 'multipleCutting', 'uBent', 'surfaceType', 'remark', 'remarks', 'mill',
      'totalWeight', 'totalWeightUom', 'weightPerLength', 'weightPerLengthUom',
      'totalLength', 'totalLengthUom', 'customerDeliveryDate', 'attachments',
      'icrIssued', 'itrIssued', 'idrIssued', 'feasibilityStatus', 'costsStatus',
      'deliveryStatus', 'feasibilityInfo', 'costsUom', 'fullCost', 'extraCosts',
      'extraCostsCollection', 'minimumFm', 'recommendedFm', 'customerBonus',
      'minimumPrice', 'recommendedPrice', 'actualFm', 'finalPrice', 'isFinalPriceManuallyChanged',
      'costsSourceDescription', 'costsSourceCostingToolVersionId',
      'costsSourceCostingToolRecordId', 'isCostsSourceManuallySelected',
      'alloySurchargeValue', 'energySurchargeValue', 'finalPricePerLength',
      'finalPricePerLengthUom', 'totalPrice', 'totalPriceUom', 'alloySurchargeValue', 'energySurchargeValue', 'isImportedFromAI'
    ];

    const orderedObject: { [key: string]: any } = {};
    propertyOrder.forEach((prop) => {
      if (item[prop] !== undefined) {
        orderedObject[prop] = item[prop];
      }
    });
    return orderedObject;
  }

  onEditCostsClick() {
    this.teiasoftLoader.start();
    this.itemsToEdit = new Array();
    this.itemsPricesFromXlsx = undefined; // to ensure that the modal will be open in edit mode instead of import mode
    this.itemsToEdit = JSON.parse(JSON.stringify(this.enquiryToEdit.items!.filter(i => i['costsStatus'] == 'Validated')));
    this.showEditCosts = true;
  }

  onSaveEditInPlaceCosts(items: any) {
    if (!this.canSaveItemsWithDeliveryWeeks(items)) {
      return;
    }

    let itemsToSend = items.map((i: EnquiryHeaderItem) => {
      let itemPrice = new ItemPrice();
      itemPrice.actualFm = i.actualFm || 0;
      itemPrice.actualFmAmountPerWeight = i.actualFmAmountPerWeight || 0;
      itemPrice.negotiationMargin = i.negotiationMargin || 0;
      itemPrice.agentFee = i.agentFee || 0;
      itemPrice.finalPrice = i.finalPrice || 0;
      itemPrice.orderExtraCost = this.enquiryToEdit.header?.orderExtraCost;
      itemPrice.itemExtraCosts = i.extraCostsCollection?.map(ec => { ec.extraCostAmount = Number(ec.extraCostAmount); return ec; }).filter(ec => ec.extraCostAmount && ec.extraCostAmount != 0); // send only valid extra costs
      return {
        itemNo: i.itemNo,
        itemPrice: itemPrice
      }
    });

    const payload = new UpdateItemsPriceAndDelivery();
    payload.itemsPrice = itemsToSend;
    payload.itemsDelivery = items
      .filter((i: EnquiryHeaderItem) => {
        const sourceItem = this.enquiryToEdit.items?.find(itm => itm.itemNo == i.itemNo);
        if (!sourceItem || !i.itemNo) return false;

        const sourceExtraLeadTime = Number(sourceItem.extraLeadTime || 0);
        const editedExtraLeadTime = Number(i.extraLeadTime || 0);
        const sourceDeliveryNotes = sourceItem.deliveryNotes || '';
        const editedDeliveryNotes = i.deliveryNotes || '';

        return sourceExtraLeadTime !== editedExtraLeadTime || sourceDeliveryNotes !== editedDeliveryNotes;
      })
      .map((i: EnquiryHeaderItem) => ({
        itemNo: i.itemNo!,
        extraLeadTime: Number(i.extraLeadTime || 0),
        deliveryNotes: i.deliveryNotes || null
      }));

    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.UpdateItemsPriceAndDelivery(this.enquiryToEdit.enquiryNo!, payload).subscribe({
      next: () => {
        this.showEditCosts = false;
        this.teiasoftLoader.stop();
        this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
        this.reloadEnquiry.emit(this.enquiryToEdit.enquiryNo);
      },
      error: () => {
        this.teiasoftLoader.stop();
      }
    }));
  }

  async createItemFromEnquiry() {
    this.teiasoftLoader.start();
    this.itemsToEdit = new Array();
    let _item: EnquiryHeaderItem = new EnquiryHeaderItem();
    await this.setDefaultValuesForNewItem(_item, true);
    this.itemsToEdit.push(_item);

    _item.customerItemNo = this.calculateNextCustomerItemNo(this.itemsToEdit);

    this.showEditInPlace = true;
    this.teiasoftLoader.stop();
  }

  getDefaultItemQtyUom(unitSystem: string, smsDescr?: string, lengthType?: string) {
    const isMetric = unitSystem === 'Metric';
    const uoms = this.itemParameterValues.quantityUoms;

    const findUom = (list: Uom[], code: string) => list?.find(qu => qu.uomCode === code)?.uomCode;

    let quantityUomValue;

    if (smsDescr === 'hollow bars') {
      quantityUomValue = isMetric ? findUom(uoms?.metricUoms!, 'kg') : findUom(uoms?.imperialUoms!, 'lb');
    } else if (lengthType === 'FL') {
      quantityUomValue = findUom(uoms?.metricUoms!, 'pcs');
    } else if (lengthType === 'RL') {
      quantityUomValue = isMetric ? findUom(uoms?.metricUoms!, 'm') : findUom(uoms?.imperialUoms!, 'ft');
    }

    return quantityUomValue || '';
  }

  getDefaultItemLength(unitSystem: string): string {
    if (unitSystem == 'Metric') {
      return this.itemParameterValues.lengthUoms?.metricUoms?.filter(x => x.isDefault)[0].uomCode || '';
    }
    else {
      return this.itemParameterValues.lengthUoms?.imperialUoms?.filter(x => x.isDefault)[0].uomCode || '';
    }
  }

  /* DIALOG FORM EVENTS */
  onDialogButtonClick_DEPRECATED(evt: DialogObject) {
    if (evt.action == 'cancel') {
      this.enquiryForm = new Array();
      this.enquiryForm = this.oldEnquiryForm.filter(x => x.field != 'fake'); //_.cloneDeep(this.oldEnquiryForm);
      this.showEditDialog = false;
    }

    if (evt.action == 'save') {
      let _enquiryToEdit: EditEnquiry = new EditEnquiry();
      _enquiryToEdit.alloySurcharge = true;
      _enquiryToEdit.applicableNorms = evt.dialogForm![14].value! == '' ? null : evt.dialogForm![14].value!;
      _enquiryToEdit.dueDate = evt.dialogForm![5].value! == '' ? null : Number(evt.dialogForm![6].value!);
      _enquiryToEdit.id = evt.dialogForm![20].value! == '' || evt.dialogForm![20].value! == undefined ? null : parseFloat(evt.dialogForm![20].value!.toString().replace(',', '.')); // MQBF-21
      _enquiryToEdit.idUom = evt.dialogForm![21].value! == '' ? null : evt.dialogForm![21].value!;
      _enquiryToEdit.marketingGradeId = null;
      _enquiryToEdit.normGradesId = new Array();
      _enquiryToEdit.normGradesId = evt.dialogForm![15].value;
      _enquiryToEdit.npsScheduleId = evt.dialogForm![24].value! == '' ? null : parseInt(evt.dialogForm![24].value!); // Verifica che ci sia l'id
      _enquiryToEdit.od = evt.dialogForm![18].value! != '' && evt.dialogForm![18].value! != undefined ? parseFloat(evt.dialogForm![18].value!.toString().replace(',', '.')) : null; // MQBF- 21
      _enquiryToEdit.odUom = evt.dialogForm![19].value! != '' ? evt.dialogForm![19].value! : null;
      _enquiryToEdit.projectName = evt.dialogForm![8].value!;
      _enquiryToEdit.rawMaterialGrade = evt.dialogForm![16].text!; //!= '' ? evt.dialogForm![16].value! : null;// Verifica che ci sia l'id
      _enquiryToEdit.remark = evt.dialogForm![27].value!;
      _enquiryToEdit.smsId = evt.dialogForm![9].value!;
      _enquiryToEdit.testCategory = null;
      _enquiryToEdit.totalWeight = parseFloat(evt.dialogForm![25].value!.toString().replace(',', '.')); // MQBF- 21
      _enquiryToEdit.totalWeightUom = evt.dialogForm![26].value!;
      _enquiryToEdit.wt = evt.dialogForm![22].value ? parseFloat(evt.dialogForm![22].value!.toString().replace(',', '.')) : null; // MQBF- 21
      _enquiryToEdit.wtUom = evt.dialogForm![23].value! != '' ? evt.dialogForm![23].value! : null;
      _enquiryToEdit.marketFamilyId = evt.dialogForm![13].value!
      _enquiryToEdit.optionDate = Number(evt.dialogForm![28].value!);

      this.editEnquiry(_enquiryToEdit, evt.attachmentsToUpdate!, evt.attachmentsToDelete!);
      _enquiryToEdit = new EditEnquiry();
    }
  }

  onDialogButtonClick(evt: DialogObject) {
    if (evt.action == 'cancel') {
      this.enquiryForm = new Array();
      this.enquiryForm = this.oldEnquiryForm.filter(x => x.field != 'fake'); //_.cloneDeep(this.oldEnquiryForm);
      this.showEditDialog = false;
    }

    if (evt.action == 'save') {
      let _enquiryToEdit: EditEnquiry = new EditEnquiry();

      _enquiryToEdit.alloySurcharge = true;

      let _i: number;

      _i = evt.dialogForm!.findIndex(x => x.field == 'unitSystem');
      let _unitSystem: string = evt.dialogForm![_i].value!;

      _enquiryToEdit.salesPersonId = evt.dialogForm!.find(x => x.field == 'salesPerson')!.value;
      _enquiryToEdit.salesOfficeId = evt.dialogForm!.find(x => x.field == 'salesOfficeId')!.value;

      _i = evt.dialogForm!.findIndex(x => x.field == 'applicableNorms');
      _enquiryToEdit.applicableNorms = evt.dialogForm![_i].value! == '' ? null : evt.dialogForm![_i].value!;

      _i = evt.dialogForm!.findIndex(x => x.field == 'customerEnquiryNo');
      _enquiryToEdit.customerEnquiryNo = evt.dialogForm![_i].value!;

      _i = evt.dialogForm!.findIndex(x => x.field == 'mstOfferStatus');
      _enquiryToEdit.mstOfferStatus = evt.dialogForm![_i].value!;

      _i = evt.dialogForm!.findIndex(x => x.field == 'dueDate');
      const dueDate = Number(evt.dialogForm![_i].value!);
      _enquiryToEdit.dueDate = dueDate && dueDate > 0 ? dueDate : null;

      _i = evt.dialogForm!.findIndex(x => x.field == 'offerValidityId');
      _enquiryToEdit.offerValidityId = evt.dialogForm![_i].value!;

      _i = evt.dialogForm!.findIndex(x => x.field == 'offerValidityDate');
      const offerValidityDate = Number(evt.dialogForm![_i].value!);
      _enquiryToEdit.offerValidityDate = offerValidityDate > 0 ? offerValidityDate : null;

      _i = evt.dialogForm!.findIndex(x => x.field == 'id');
      let _value: number | null = evt.dialogForm![_i].value! != '' && evt.dialogForm![_i].value! != undefined ? parseFloat(evt.dialogForm![_i].value!.toString().replace(',', '.')) : null;
      let _digits: number = 2;
      if (_unitSystem == 'Metric') {
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'od')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'id')[0].metricDigits! : 2;
      } else {
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'od')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'id')[0].metricDigits! : 2;
      }
      _enquiryToEdit.id = _value != null ? parseFloat(_value.toFixed(_digits)) : null;

      _i = evt.dialogForm!.findIndex(x => x.field == 'idUom');
      _enquiryToEdit.idUom = evt.dialogForm![_i].value! == '' ? null : evt.dialogForm![_i].value!;

      _enquiryToEdit.marketingGradeId = null;

      _i = evt.dialogForm!.findIndex(x => x.field == 'normGrades');
      _enquiryToEdit.normGradesId = new Array();
      _enquiryToEdit.normGradesId = evt.dialogForm![_i].value;

      _i = evt.dialogForm!.findIndex(x => x.field == 'npsDescription');
      _enquiryToEdit.npsScheduleId = evt.dialogForm![_i].value! == '' ? null : parseInt(evt.dialogForm![_i].value!); // Verifica che ci sia l'id

      _i = evt.dialogForm!.findIndex(x => x.field == 'od');
      _value = evt.dialogForm![_i].value! != '' && evt.dialogForm![_i].value! != undefined ? parseFloat(evt.dialogForm![_i].value!.toString().replace(',', '.')) : null;
      if (_unitSystem == 'Metric') {
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'od')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'od')[0].metricDigits! : 2;
      } else {
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'od')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'od')[0].metricDigits! : 2;
      }
      _enquiryToEdit.od = _value != null ? parseFloat(_value.toFixed(_digits)) : null;

      _i = evt.dialogForm!.findIndex(x => x.field == 'odUom');
      _enquiryToEdit.odUom = evt.dialogForm![_i].value! != '' ? evt.dialogForm![_i].value! : null;

      _i = evt.dialogForm!.findIndex(x => x.field == 'orderReason');
      _enquiryToEdit.orderReason = evt.dialogForm![_i].value!;

      _i = evt.dialogForm!.findIndex(x => x.field == 'projectName');
      _enquiryToEdit.projectName = evt.dialogForm![_i].value!;

      _i = evt.dialogForm!.findIndex(x => x.field == 'rawMaterialGrades');
      _enquiryToEdit.rawMaterialGrade = evt.dialogForm![_i].text!; //!= '' ? evt.dialogForm![_i].value! : null;// Verifica che ci sia l'id

      _i = evt.dialogForm!.findIndex(x => x.field == 'remark');
      _enquiryToEdit.remark = evt.dialogForm![_i].value!;

      _i = evt.dialogForm!.findIndex(x => x.field == 'sms');
      _enquiryToEdit.smsId = evt.dialogForm![_i].value!;

      _enquiryToEdit.testCategory = null;

      _i = evt.dialogForm!.findIndex(x => x.field == 'totalWeight');
      _value = evt.dialogForm![_i].value! != '' && evt.dialogForm![_i].value! != undefined ? parseFloat(evt.dialogForm![_i].value!.toString().replace(',', '.')) : null;
      if (_unitSystem == 'Metric') {
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'totalweight')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'totalweight')[0].metricDigits! : 2;
      } else {
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'totalweight')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'totalweight')[0].metricDigits! : 2;
      }
      if (_value)
        _enquiryToEdit.totalWeight = parseFloat(_value!.toFixed(_digits));

      _i = evt.dialogForm!.findIndex(x => x.field == 'totalWeightUom');
      _enquiryToEdit.totalWeightUom = evt.dialogForm![_i].value!;

      _i = evt.dialogForm!.findIndex(x => x.field == 'wt');
      _value = evt.dialogForm![_i].value! != '' && evt.dialogForm![_i].value! != undefined ? parseFloat(evt.dialogForm![_i].value!.toString().replace(',', '.')) : null;
      if (_unitSystem == 'Metric') {
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'wt')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'wt')[0].metricDigits! : 2;
      } else {
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'wt')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'wt')[0].metricDigits! : 2;
      }
      _enquiryToEdit.wt = _value != null ? parseFloat(_value!.toFixed(_digits)) : null;

      _i = evt.dialogForm!.findIndex(x => x.field == 'wtUom');
      _enquiryToEdit.wtUom = evt.dialogForm![_i].value! != '' ? evt.dialogForm![_i].value! : null;

      _i = evt.dialogForm!.findIndex(x => x.field == 'marketFamily');
      _enquiryToEdit.marketFamilyId = evt.dialogForm![_i].value!

      // special requirements
      _enquiryToEdit.customerSpecialRequirements = this.enquiryToEdit.header!.customerSpecialRequirements || [];
      
      _i = evt.dialogForm!.findIndex(x => x.field == 'offerSchemeCode');
      if (_i !== -1) {
        const offerSchemeCode = evt.dialogForm![_i].value;
        _enquiryToEdit.offerSchemeCode = offerSchemeCode != null && offerSchemeCode !== '' ? offerSchemeCode : null;
      }

      _i = evt.dialogForm!.findIndex(x => x.field == 'bonusSchemeCode');
      if (_i !== -1) {
        const bonusSchemeCode = evt.dialogForm![_i].value;
        _enquiryToEdit.bonusSchemeCode = bonusSchemeCode != null && bonusSchemeCode !== '' ? bonusSchemeCode : null;
      }

      this.editEnquiry(_enquiryToEdit, evt.attachmentsToUpdate!, evt.attachmentsToDelete!);
      _enquiryToEdit = new EditEnquiry();
    }

    if (evt.action == 'specialRequirements') {
      this.showSpecialRequirements = true;
    }
  }

  onFormButtonClick(evt: any) {
    let _action: string = "";
    if (evt["action"]) _action = evt["action"];
    if (_action == 'select|customer') {
      this.getCustomers();
    }

    if (_action.endsWith("nps")) { //|| _action.endsWith("wtOdIt")) {
      let _temp: string[] = new Array();
      _temp = _action.split("|");
      //if (this.prevToogleButton != _temp[1]) this.setWtOdIdNps(_temp[1], true); // GBR 25/01/2024  
      // this.setWtOdIdNps(_temp[1], true);
      this.prevToogleButton = _temp[1];
      //this.getNpsAndSchedules(true); // GBR 25/01/2024
      this.showSelectNps = true;
    }

    if (_action.endsWith("wtOdIt")) {
      let _temp: string[] = new Array();
      _temp = _action.split("|");
      //if (this.prevToogleButton != _temp[1]) this.setWtOdIdNps(_temp[1], true);
      this.setWtOdIdNps(_temp[1], true);
      this.prevToogleButton = _temp[1];
    }
  }

  onFormSelectListChanged(evt: any) {

  }

  onFormAutocompleteChanged(evt: any) {
    if (evt.field == 'customer') {
      let _customerId: number | null = null;
      let _customerName: string = "";
      let _countryId: number | null = null;
      let _countryName: string = "";
      let _customerCode: string = "";
      let _unitSystem: string = "";

      if (evt.object! != '') {
        let _data: any = JSON.parse(evt.object!);
        _customerId = _data["customerId"];
        _customerName = _data["customerName"];
        _countryId = _data["customerCountry"]["countryId"];
        _countryName = _data["customerCountry"]["countryName"];
        _customerCode = _data["customerCode"];
        _unitSystem = _data["unitSystem"];
      }

      let _i: number = this.enquiryForm.findIndex(x => x.field == 'customerName');
      this.enquiryForm[_i].value = _customerId; // _data["customerId"];
      this.enquiryForm[_i].text = _customerName; // _data["customerName"];
      this.enquiryForm[_i].isValid = true;

      _i = this.enquiryForm.findIndex(x => x.field == 'customerCountry');
      this.enquiryForm[_i].value = _countryId;// _data["customerCountry"]["countryId"];
      this.enquiryForm[_i].text = _countryName; // _data["customerCountry"]["countryName"];

      _i = this.enquiryForm.findIndex(x => x.field == 'customerCode');
      this.enquiryForm[_i].isRequired = true;
      this.enquiryForm[_i].value = _customerCode; // _data["customerCode"];
      this.enquiryForm[_i].text = _customerCode; //_data["customerCode"];

      _i = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
      this.enquiryForm[_i].value = _unitSystem; //_data["unitSystem"];
      this.enquiryForm[_i].text = _unitSystem; //_data["unitSystem"];

      _i = this.enquiryForm.findIndex(x => x.field == 'customerId');
      this.enquiryForm[_i].value = _customerId; // _data["customerId"];
      this.enquiryForm[_i].text = _customerId; //_data["customerId"];

      /*       let _data: any = JSON.parse(evt.object!);
            let _i: number = this.enquiryForm.findIndex(x => x.field == 'customerName');
            this.enquiryForm[_i].value = _data["customerName"];
            this.enquiryForm[_i].text = _data["customerName"];
            this.enquiryForm[_i].isValid = true;
            
            _i = this.enquiryForm.findIndex(x => x.field == 'customerCountry');
            this.enquiryForm[_i].value = _data["customerCountry"];
            this.enquiryForm[_i].text = _data["customerCountry"];
      
            _i = this.enquiryForm.findIndex(x => x.field == 'customerCode');
            this.enquiryForm[_i].isRequired = true;
            this.enquiryForm[_i].value = _data["customerCode"];
            this.enquiryForm[_i].text = _data["customerCode"];
      
            _i = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
            this.enquiryForm[_i].value = _data["unitSystem"];
            this.enquiryForm[_i].text = _data["unitSystem"];
      
            _i = this.enquiryForm.findIndex(x => x.field == 'customerId');
            this.enquiryForm[_i].value = _data["customerId"];
            this.enquiryForm[_i].text = _data["customerId"]; */

      this.setSelectUoms();
      //_data = "";
    }

    if (evt.field == 'rawMaterialGrades') {
      let _data: any = JSON.parse(evt.object!);
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'rawMaterialGrades');
      this.enquiryForm[_i].value = _data["rawMaterialGradeId"];
      this.enquiryForm[_i].text = _data["rawMaterialGradeCode"];
      this.enquiryForm[_i].isValid = true;
      _data = "";
    }

    if (evt.field == 'sms') {
      let _data: any = JSON.parse(evt.object!);
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'sms');
      this.enquiryForm[_i].value = _data["smsId"];
      this.enquiryForm[_i].text = _data["name"];
      _data = "";
    }
  }

  onFormAutocompletLinkClicked(evt: any) {

  }

  onFormSelectChanged(evt: DialogSelect) {
    // if (!this.isFormReady) return;
    // First Run
    if (!evt.option) return;

    if (evt.field == 'salesPerson') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'salesPerson');
      this.enquiryForm[_i].value = evt.option.value!;
      this.enquiryForm[_i].text = evt.option.text!;
      let _iO: number = this.enquiryForm.findIndex(x => x.field == 'salesOfficeId');
      let _offices: SalesOfficePerson[] = new Array();
      _offices = this.headerParametersValues.salesPersons!.filter(x => x.userId == evt.option!.value!)[0].salesOffices!;
      let _list: SelectOption[] = new Array();
      for (var x = 0; x < _offices!.length; x++) {
        let _item: SelectOption = new SelectOption();
        _item.value = _offices[x].officeId;
        _item.text = this.headerParametersValues.salesOffices!.filter(o => o.officeId == _offices[x].officeId)[0].officeCode!;
        _list.push(_item);
      }
      this.enquiryForm[_iO].optionsList = new Array();
      this.enquiryForm[_iO].optionsList = _list;
      this.enquiryForm[_iO].value = _offices.filter(o => o.isDefault! == true)[0].officeId
      this.enquiryForm[_iO].text = this.headerParametersValues.salesOffices!.filter(x => x.officeId == this.enquiryForm[_iO].value)[0].officeCode!;
    }

    // SALES OFFICE CHANGED
    if (evt.field == 'salesOfficeId') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'salesOfficeId');
      this.enquiryForm[_i].value = evt.option.value!;
      this.enquiryForm[_i].text = evt.option.text!;
    }


    // ORDER REASON CHANGED
    if (evt.field == 'orderReason') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'orderReason');
      this.enquiryForm[_i].value = evt.option.value!;
      this.enquiryForm[_i].text = evt.option.text!;

      // MQF 169 - Prefill di MarketFamily sulla base dell'order reason selezionato
      /* let _iMf: number = this.enquiryForm.findIndex(x => x.field == 'marketFamily');
      let _mf: MarketFamily = new MarketFamily();
      if (evt.option.value! == 'Project')
        _mf = this.headerParametersValues.marketFamily!.filter(x => x.isDefaultForProject == true)[0];
      else
        _mf = this.headerParametersValues.marketFamily!.filter(x => x.isDefaultForDistribution == true)[0];
  
      if (_mf){
        this.enquiryForm[_iMf].value = _mf.marketFamilyId;
        this.enquiryForm[_iMf].text = _mf.name;
      } */
    }

    // UNIT SYSTEM CHANGED
    if (evt.field == 'unitSystem') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
      if (this.enquiryForm[_i].value != evt.option!.value) {
        this.enquiryForm[_i].value = evt.option!.value;
        this.enquiryForm[_i].text = evt.option!.text;
        this.setSelectUoms();
      }
    }

    if (evt.field == 'alloySurcharge') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'alloySurcharge');
      if (this.enquiryForm[_i].value != evt.option!.value) {
        this.enquiryForm[_i].value = evt.option!.value;
        this.enquiryForm[_i].text = evt.option!.text;
      }
    }

    if (evt.field == 'mstOfferStatus') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'mstOfferStatus');
      if (this.enquiryForm[_i].value != evt.option!.value) {
        this.enquiryForm[_i].value = evt.option!.value;
        this.enquiryForm[_i].text = evt.option!.text;
      }
    }

    if (evt.field == 'totalWeightUom') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'totalWeight');
      if (this.enquiryForm[_i].disabled) {
        this.teiasoftToaster.show("info", this.translate.instant("enquiryBook.totalWeightUpdate"));
      }
    }

    if (evt.field == 'smsMarketingRoute') {
      let _iO: number = this.enquiryForm.findIndex(x => x.field == 'sms');

      let optionList = this.getSmsOptionList(evt.option.value);

      this.enquiryForm[_iO].optionsList = new Array();
      this.enquiryForm[_iO].optionsList = optionList || new Array();

      if (this.enquiryForm[_iO].optionsList?.map(o => o.text).includes(this.enquiryForm[_iO].text)) {
        this.enquiryForm[_iO].value = this.enquiryForm[_iO].optionsList?.find(o => o.text == this.enquiryForm[_iO].text)?.value;
      }
      else {
        this.enquiryForm[_iO].value = '';
        this.enquiryForm[_iO].text = '';
      }

    }

    // offer validity CHANGED
    if (evt.field == 'offerValidityId') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'offerValidityId');
      let _iDate: number = this.enquiryForm.findIndex(x => x.field == 'offerValidityDate');
      this.enquiryForm[_i].value = evt.option!.value;

      // if this option is custom show  offerValidityDate
      const isCustomOfferValidity = this.headerParametersValues.offerValidities!.filter(ov => ov.isCustom && ov.id == this.enquiryForm[_i].value).length > 0;

      this.enquiryForm[_iDate].visible = isCustomOfferValidity;
      this.enquiryForm[_iDate].isRequired = isCustomOfferValidity;

      if (!isCustomOfferValidity) {
        this.enquiryForm[_iDate].value = null;
        this.enquiryForm[_iDate].text = null;
      }
    }

    // MARKETING GRADE CHANGED
    /*     if (evt.field == 'marketingGrades'){
          let _i: number = this.enquiryForm.findIndex(x => x.field == evt.field);
          this.enquiryForm[_i].value = evt.option!.value;
          
          _i = this.enquiryForm.findIndex(x => x.field == 'rawMaterialGrades');
          this.enquiryForm[_i].optionsList = new Array();
          this.enquiryForm[_i].optionsList = this.getRawMaterialGrades();
        } */

  }

  getSmsOptionList(marketingRoute: string) {

    let sms = this.headerParametersValues.sms!;

    if (marketingRoute) {
      sms = sms.filter(s => s.marketingRoute === marketingRoute)
    }

    return sms?.map(s => {
      let opt = new SelectOption();
      opt.text = s.description;
      opt.value = s.smsId;

      return opt;
    });
  }

  onFormAutocompleteChangedRows(evt: Autocomplete) {
    if (evt.field == 'normGrades') {
      let _data: any[] = JSON.parse(evt.object!);
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'normGrades');
      let _ids: number[] = new Array();
      let _codes: string[] = new Array();
      for (var x = 0; x < _data.length; x++) {
        _ids.push(_data[x]["normGradeId"]);
        _codes.push(_data[x]["normGradeCode"]);
      }
      this.enquiryForm[_i].value = _ids;
      this.enquiryForm[_i].text = _codes;
      this.enquiryForm[_i].isValid = true;
      //console.log("[QuoteTool] EditEnquiry Selected Rows", _data);
      // Se ho selezionato qualcosa abilito le RawMaterialGrade
      if (_ids.length > 0) {
        this.getRawMaterialGrades('', _ids);
      }
    }
  }

  onFormReady(evt: boolean) {
    this.isFormReady = evt;
  }

  onConfirmModalNps(evt: any) {
    /*     let _i: number = this.enquiryForm.findIndex( x => x.field == 'npsDescription');
        this.enquiryForm[_i].text = evt["npsDescription"];
        this.enquiryForm[_i].value = evt["npsScheduleId"];
        this.showSelectNps = false;
        this.selectedNpsRow = new NpsAndSchedule();
        this.selectedNpsRow = evt; */

    // Check which unit system is selected
    let _i: number = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
    let _uomSystem: string = this.enquiryForm[_i].value;
    if (_uomSystem == '') {
      this.teiasoftModalService.show('info', this.translate.instant('enquiryBook.add'), this.translate.instant('enquiryBook.selectUomSystem'), '', '');
      return;
    }

    // NPS DESCRIPTION
    _i = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
    this.enquiryForm[_i].text = evt["npsDescription"];
    this.enquiryForm[_i].value = evt["npsScheduleId"];
    this.enquiryForm[_i].isValid = true;

    // OD
    _i = this.enquiryForm.findIndex(x => x.field == 'od');
    if (_uomSystem.toLowerCase() == 'metric') {
      this.enquiryForm[_i].text = evt["odMetric"];
      this.enquiryForm[_i].value = evt["odMetric"];
    } else {
      this.enquiryForm[_i].text = evt["odImperial"];
      this.enquiryForm[_i].value = evt["odImperial"];
    }

    // OD UOM
    _i = this.enquiryForm.findIndex(x => x.field == 'odUom');
    this.enquiryForm[_i].optionsList = new Array();
    this.enquiryForm[_i].optionsList = this.getUoms('odUoms');
    this.enquiryForm[_i].value = _uomSystem.toLowerCase() == 'metric' ? evt["metricUom"] : evt["imperialUom"]; // this.enquiryForm[_i].optionsList![0].value!;
    this.enquiryForm[_i].text = _uomSystem.toLowerCase() == 'metric' ? evt["metricUom"] : evt["imperialUom"]; // this.enquiryForm[_i].optionsList![0].text!;

    // WT
    _i = this.enquiryForm.findIndex(x => x.field == 'wt');
    if (_uomSystem.toLowerCase() == 'metric') {
      this.enquiryForm[_i].text = evt["wtMetric"];
      this.enquiryForm[_i].value = evt["wtMetric"];
    } else {
      this.enquiryForm[_i].text = evt["wtImperial"];
      this.enquiryForm[_i].value = evt["wtImperial"];
    }

    // WT UOM
    _i = this.enquiryForm.findIndex(x => x.field == 'wtUom');
    this.enquiryForm[_i].optionsList = new Array();
    this.enquiryForm[_i].optionsList = this.getUoms('wtUoms');
    this.enquiryForm[_i].value = _uomSystem.toLowerCase() == 'metric' ? evt["metricUom"] : evt["imperialUom"]; //this.enquiryForm[_i].optionsList![0].value!;
    this.enquiryForm[_i].text = _uomSystem.toLowerCase() == 'metric' ? evt["metricUom"] : evt["imperialUom"]; //this.enquiryForm[_i].optionsList![0].text!;

    // EMPTY ID / ID UOM
    _i = this.enquiryForm.findIndex(x => x.field == 'id');
    this.enquiryForm[_i].value = null;
    this.enquiryForm[_i].text = null;

    _i = this.enquiryForm.findIndex(x => x.field == 'idUom');
    this.enquiryForm[_i].value = null;
    this.enquiryForm[_i].text = null;

    this.showSelectNps = false;
    this.selectedNpsRow = new NpsAndSchedule();
    this.selectedNpsRow = evt;
    $('.teia-tt-toggle-pressed').focus(); // GBR MQBF-23
  }

  onCloseModalNps(evt: any) {
    // If the pre-value is Nps I don't do nothing - GBR 25/01/2024
    let _i: number;
    _i = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
    // Prima c'era WtOdId
    let _iTb = this.enquiryForm.findIndex(x => x.field == 'toolbarWtOdIdNps');
    if (this.enquiryForm[_i].value == '' && this.enquiryForm[_i].text == '') {
      // this.setWtOdIdNps('wtOdId', false);
      this.enquiryForm![_iTb].toolbarButtonsList![0].state = 'pressed';
      this.enquiryForm![_iTb].toolbarButtonsList![1].state = '';
    }
    this.showSelectNps = false;
    $('.teia-tt-toggle-pressed').focus(); // GBR MQBF-23
  }

  onFormAutocompleteInputChange(evt: Autocomplete) {
    if (evt.field == 'customer') {
      let _i: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'customername');
      this.enquiryForm[_i].autoCompleteDataset = new Array();
      this.enquiryForm[_i].autoCompleteDataset = [
        // Customers whose name starts with the value
        ...this.headerParametersValues.customers!.filter(x =>
          x.customerName!.toLowerCase().startsWith(evt.object!.toLowerCase())
        ).sort((a, b) => a.customerName!.localeCompare(b.customerName!)),

        // Customers whose name contains the value but don't start with it
        ...this.headerParametersValues.customers!.filter(x =>
          x.customerName!.toLowerCase().includes(evt.object!.toLowerCase()) &&
          !x.customerName!.toLowerCase().startsWith(evt.object!.toLowerCase())
        ).sort((a, b) => a.customerName!.localeCompare(b.customerName!))
      ];
    }

    if (evt.field == 'normGrades') {
      this.getNormGrades(evt.object!);
    }

    if (evt.field == 'rawMaterialGrades') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'normGrades');
      this.getRawMaterialGrades(evt.object!, this.enquiryForm[_i].value!);
    }

    /*     if (evt.field == 'sms') {
          let _i: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'sms');
          this.enquiryForm[_i].autoCompleteDataset = new Array();
          this.enquiryForm[_i].autoCompleteDataset = this.headerParametersValues.sms!.filter(x => x.name!.toLowerCase().includes(evt.object!.toLowerCase()));
        } */

    if (evt.field == 'id' || evt.field == 'od' || evt.field == 'wt') {
      this.checkWtOdId();
    }

  }

  checkWtOdId() {
    let _iOd: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'od');
    let _odValue: any = this.enquiryForm[_iOd].value ? this.enquiryForm[_iOd].value : '';

    let _iId: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'id');
    let _idValue: any = this.enquiryForm[_iId].value ? this.enquiryForm[_iId].value : '';

    let _iWt: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'wt');
    let _wtValue: any = this.enquiryForm[_iWt].value ? this.enquiryForm[_iWt].value : '';

    if (_odValue != '' && _idValue == '' && _wtValue == '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = true;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = false;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = false;
    }

    if (_odValue == '' && _idValue != '' && _wtValue == '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = false;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = true;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = false;
    }

    if (_odValue == '' && _idValue == '' && _wtValue != '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = false;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = false;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = true;
    }

    if (_odValue != '' && _idValue != '' && _wtValue == '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = true;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = true;
      this.enquiryForm[_iWt].isRequired = false;
      this.enquiryForm[_iWt].isValid = true;
    }

    if (_odValue == '' && _idValue != '' && _wtValue != '') {
      this.enquiryForm[_iOd].isRequired = false;
      this.enquiryForm[_iOd].isValid = true;

      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = true;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = true;
    }

    if (_odValue != '' && _idValue == '' && _wtValue != '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = true;

      this.enquiryForm[_iId].isRequired = false;
      this.enquiryForm[_iId].isValid = true;

      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = true;

    }

  }

  onFormAutocompleteRemoveElement(evt: Autocomplete) {
    if (evt.field == 'normGrades') {
      let _i: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'normgrades');
      // REMOVE TEXT
      let _texts: string[] = this.enquiryForm[_i].text.toString().split(',');
      let _x: number = _texts.findIndex(x => x == evt.object);
      this.enquiryForm[_i].text = _texts.filter(x => x != evt.object); //.join(',');

      // REMOVE VALUE
      let _values: any[] = this.enquiryForm[_i].value.toString().split(',');
      let _valToRemove = this.enquiryForm[_i].value.toString().split(',')[_x];
      this.enquiryForm[_i].value = _values.filter(x => x != _valToRemove); //.join(',');

      // CLEAR RAW MATERIAL GRADES
      let _ids: number[] = new Array();
      if (this.enquiryForm![_i].value! != '') {
        for (var x = 0; x < this.enquiryForm![_i].value!.toString().split(',').length; x++) {
          _ids.push(parseInt(this.enquiryForm![_i].value!.toString().split(',')[x]));
        }
      }


      if (_ids.length > 0) {
        this.getRawMaterialGrades('', _ids);
      } else {
        _i = this.enquiryForm.findIndex(x => x.field! == 'rawMaterialGrades');
        this.enquiryForm[_i].value = null;
        this.enquiryForm[_i].text = null;
        this.enquiryForm[_i].autoCompleteDataset = new Array();
        this.enquiryForm[_i].disabled = true;
        // MQF-401
        this.enquiryForm[_i].isRequired = false;
      }
    }
  }

  /* EDITABLE FIELDS IN GRID */
  onHotChange(isChanging: boolean) {
    this.itemButtonsDisabled = isChanging;
  }

  async onApplyModificationFromEdit() {
    if (this.isCalculatingMargins) {
      // wait until calculations are done
      await new Promise(resolve => {
        setTimeout(() => {
          resolve(true);
        }, 1500);
      });
    }

    if (!this.canSaveItemsWithDeliveryWeeks(this.enquiryToEdit.items || [])) {
      return;
    }

    // send only the items edited
    let itemsToSend = this.dataSetItems.filter(i => i.costUpdated).map((i: EnquiryHeaderItem) => {
      let itemPrice = new ItemPrice();
      itemPrice.actualFm = i.actualFm || 0;
      itemPrice.actualFmAmountPerWeight = i.actualFmAmountPerWeight || 0;
      itemPrice.negotiationMargin = i.negotiationMargin || 0;
      itemPrice.agentFee = i.agentFee || 0;
      itemPrice.finalPrice = i.finalPrice || 0;
      itemPrice.orderExtraCost = this.enquiryToEdit.header?.orderExtraCost;
      itemPrice.itemExtraCosts = this.enquiryToEdit!.items?.find(itm => itm.itemNo == i.itemNo)?.extraCostsCollection || []; // send only valid extra costs
      return {
        itemNo: i.itemNo!,
        itemPrice: itemPrice
      }
    });

    let extraLeadTimeToSend = this.dataSetItems.filter(i => i.extraLeadTimeEdited || i.deliveryNotesEdited).map(i => {
      return {
        itemNo: i.itemNo,
        extraLeadTime: i.extraLeadTime,
        deliveryNotes: i.deliveryNotes
      }
    })

    const payload = new UpdateItemsPriceAndDelivery();
    payload.itemsPrice = itemsToSend;
    payload.itemsDelivery = extraLeadTimeToSend;

    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.UpdateItemsPriceAndDelivery(this.enquiryToEdit.enquiryNo!, payload).subscribe((res) => {
      this.teiasoftLoader.stop();
      this.priceEdited = false;
      this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      this.reloadEnquiry.emit(this.enquiryToEdit.enquiryNo);
    }));
  }

  onDiscardModificationFromEdit() {
    this.priceEdited = false;
    this.reloadEnquiry.emit(this.enquiryToEdit.enquiryNo);
  }

  onItemExtraCostsClick(item: any) {
    this.selectedExtraCostItem = item;
    this.showExtraCosts = true;
  }

  onOrderExtraCostsClick(): void {
    this.showOrderExtraCosts = true;
  }

  onItemDeliveryDatesClick(item: any) {
    this.selectedDeliveryDatesItem = this.enquiryToEdit.items?.find(i => i.itemNo == item.itemNo);
    this.showItemDeliveryDates = true;
  }

  onSaveOrderExtraCosts($event: OrderExtraCost) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.setOrderExtraCost(this.enquiryToEdit.enquiryNo!, $event).subscribe({
      next: () => {
        this.showOrderExtraCosts = false;
        this.reloadEnquiry.emit(this.enquiryToEdit.enquiryNo);
        this.teiasoftLoader.stop();
        this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      },
      error: () => {
        this.teiasoftLoader.stop();
      }
    }));
  }

  onSaveItemExtraCosts($event: any) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.setItemExtraCosts(this.enquiryToEdit.enquiryNo!, this.selectedExtraCostItem!.itemNo!, $event).subscribe({
      next: () => {
        this.showExtraCosts = false;
        this.reloadEnquiry.emit(this.enquiryToEdit.enquiryNo);
        this.teiasoftLoader.stop();
        this.items = [];
        this.selectedExtraCostItem = null;
        this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      },
      error: () => {
        this.teiasoftLoader.stop();
      }
    }));
  }

  safeToFixed(value: any, decimals: number = 2): number {
    const num = Number(value);
    return isNaN(num) ? 0 : Number(num.toFixed(decimals));
  }


  private beginPriceCalculation(): void {
    this.pendingPriceCalculations++;
    this.isCalculatingMargins = true;
  }

  private endPriceCalculation(): void {
    this.pendingPriceCalculations = Math.max(this.pendingPriceCalculations - 1, 0);
    if (this.pendingPriceCalculations === 0) {
      this.isCalculatingMargins = false;
    }
  }

  calculateItemMarginsAndPrices(item: EnquiryHeaderItem, field: "ActualFm" | "ActualFmAmountPerWeight" | "NegotiationMargin" | "AgentFee" | "FinalPrice" | "ItemExtraCosts") {
    const payload = new CalculateMarginsAndPricesPayload();
    payload.changedField = field;
    payload.previousFinalPrice = field == 'FinalPrice' ? Number(this.previousFinalPrice?.toFixed(2)) : undefined;
    payload.itemPrice = new ItemPrice();
    payload.itemPrice.actualFm = this.safeToFixed(item.actualFm);
    payload.itemPrice.actualFmAmountPerWeight = this.safeToFixed(item.actualFmAmountPerWeight);
    payload.itemPrice.agentFee = this.safeToFixed(item.agentFee);
    payload.itemPrice.negotiationMargin = this.safeToFixed(item.negotiationMargin);
    payload.itemPrice.finalPrice = this.safeToFixed(item.finalPrice);
    payload.itemPrice.itemExtraCosts = this.enquiryToEdit.items?.find(i => i.itemNo === item.itemNo)?.extraCostsCollection;
    payload.itemPrice.orderExtraCost = this.enquiryToEdit.header?.orderExtraCost;

    this.beginPriceCalculation();

    const calculation$ = this.backendService.calculateMarginsAndPrices(this.enquiryToEdit.enquiryNo!, item.itemNo!, payload)
      .pipe(finalize(() => this.endPriceCalculation()));

    this.subscriptions.add(calculation$.subscribe(res => {
      if (res) {
        const resItem = res;
        if (resItem) {
          item.actualFm = resItem.actualFm;
          item.actualFmAmountPerWeight = resItem.actualFmAmountPerWeight;
          item.agentFee = resItem.agentFee;
          item.negotiationMargin = resItem.negotiationMargin;
          item.finalPrice = resItem.finalPrice;
          item.extraCosts = resItem.extraCosts;
          item.minimumPrice = resItem.minimumPrice;
          item.recommendedPrice = resItem.recommendedPrice;
          item.finalPricePerLength = resItem.finalPricePerLength;
        }
      }
    }, () => { }));
  }


  calculateItemFinalPrice(item: EnquiryHeaderItem) {
    const baseCost = Number(item.fullCost) + Number(item.extraCosts) + Number(item.actualFm);
    const priceWithNegotiation = baseCost + (baseCost * (item.negotiationMargin! / 100));
    const finalPrice = priceWithNegotiation / (1 - (item.agentFee! / 100));

    item.finalPrice = Number.isFinite(finalPrice) ? Number(finalPrice.toFixed(2)) : Number();
  }


  recalculateMargins(item: EnquiryHeaderItem, inputFinalPrice: number, prevFinalPrice: number): void {

    if (inputFinalPrice > prevFinalPrice) {

      const agentMultiplier = 1 - (item.agentFee! / 100);
      const partialPrice = inputFinalPrice * agentMultiplier;
      const basePrice = partialPrice / (1 + (item.negotiationMargin! / 100));

      // The Actual Margin increases accordingly.
      const newActualCm = basePrice - (item.fullCost! + item.extraCosts!);
      item.actualFm = Math.round(newActualCm * 100) / 100;
    }
    else {
      let basePrice = Number(item.fullCost) + Number(item.extraCosts) + Number(item.actualFm);

      const agentMultiplier = 1 - (item.agentFee! / 100);
      const partialPrice = inputFinalPrice * agentMultiplier;

      const negotiationMargin = ((partialPrice / basePrice) - 1) * 100;

      if (negotiationMargin > 0) {
        item.negotiationMargin = negotiationMargin;
      } else {
        // If negotiation margin reaches 0, reduce the Actual CM instead
        item.negotiationMargin = 0;
        basePrice = partialPrice; // Base price without negotiation margin

        // Adjust Actual CM
        const newActualCm = basePrice - (item.fullCost! + item.extraCosts!);
        item.actualFm = Math.round(newActualCm * 100) / 100;
      }
    }
  }

  onInputFocusOut($event: any, row: any, rowProperty: string) {
    row[rowProperty] = Number(row[rowProperty] || 0).toFixed(2);
  }

  onPriceChange($event: any, originalValue: any, allowNegative: boolean = true) {
    const inputEl = $event.target as HTMLInputElement;
    let value = inputEl.value;

    // Replace commas with dots
    value = value.replace(',', '.');

    // Build regex depending on whether negative is allowed
    if (!allowNegative) {
      value = value.replace(/[^0-9.]/g, ''); // Only digits and dot
    } else {
      value = value
        .replace(/[^0-9.\-]/g, '')   // Allow digits, one dot, minus
        .replace(/(?!^)-/g, '');     // Remove any minus not at the start
    }

    // Allow only one dot
    value = value.replace(/^(-?\d*)\.(.*)\.(.*)$/, '$1.$2');

    // If negatives are disallowed, remove any leading minus that may remain
    if (!allowNegative && value.startsWith('-')) {
      value = value.substring(1);
    }

    inputEl.value = value;

    if (value !== String(originalValue) && !((value === '' || value === null) && (String(originalValue) === '0' || originalValue === 0))) {
      this.priceEdited = true;
    }
  }


  onInputMargin($event: any, row: any, column: string) {
    $event.target.value = $event.target.value.toString().replaceAll(',', '.');
    if (isNaN($event.target.value))
      return;

    if (column === 'agentFee' && !this.isAgentFeeEditable(row)) {
      $event.target.value = Number(row[column] || 0).toFixed(2);
      return;
    }

    if (Number($event.target.value) == Number(row[column])) {
      return;
    }

    const value = $event.target.value == "" ? 0 : $event.target.value;
    row[column] = Number.parseFloat(value);
    $event.target.value = row[column].toFixed(2);


    // this.calculateItemFinalPrice(row);
    let field: "NegotiationMargin" | "AgentFee" = column === 'NegotiationMargin' ? 'NegotiationMargin' : 'AgentFee';
    this.calculateItemMarginsAndPrices(row, field);
    row.costUpdated = true;
    row.priceEdited = true;
    this.updateGlobalPriceEdited();

  }

  isAgentFeeEditable(row: EnquiryHeaderItem): boolean {
    return !Number.isFinite(row?.customerBonus);
  }

  onInputActualCm($event: any, row: any, column: 'actualFm' | 'actualFmAmountPerWeight' = 'actualFm') {

    $event.target.value = $event.target.value.toString().replaceAll(',', '.');

    if (isNaN($event.target.value))
      return;

    if (Number($event.target.value) == Number(row[column])) {
      return;
    }

    const value = $event.target.value == "" ? 0 : $event.target.value;
    const inputValue = Number.parseFloat(value);
    $event.target.value = inputValue.toFixed(2);
    row[column] = inputValue;

    const changedField: "ActualFm" | "ActualFmAmountPerWeight" = column === 'actualFmAmountPerWeight'
      ? 'ActualFmAmountPerWeight'
      : 'ActualFm';
    this.calculateItemMarginsAndPrices(row, changedField);
    row.costUpdated = true;
    row.priceEdited = true;
    this.updateGlobalPriceEdited();
  }

  onInputExtraLeadTime($event: any, row: any) {
    $event.target.value = $event.target.value.toString().replaceAll(',', '.');
    if (isNaN($event.target.value))
      return;

    if (Number($event.target.value) == Number(row['extraLeadTime'])) {
      return;
    }

    const value = this.toRoundedInteger($event.target.value == "" ? 0 : $event.target.value);
    $event.target.value = value;
    row['extraLeadTime'] = value;
    const sourceItem = this.enquiryToEdit.items?.find(i => i.itemNo == row.itemNo);
    if (sourceItem) {
      sourceItem.extraLeadTime = value;
      this.updateDeliveryDatesWithExtraLeadTime(sourceItem, value);
    }
    row.extraLeadTimeEdited = true;
    row.priceEdited = true;
    this.updateGlobalPriceEdited();
  }

  private toRoundedInteger(value: any): number {
    const parsedValue = Number(value);
    if (!Number.isFinite(parsedValue)) return 0;
    return Math.round(parsedValue);
  }

  private updateDeliveryDatesWithExtraLeadTime(item: EnquiryHeaderItem, extraLeadTime?: number): void {
    if (!item) return;

    const deliverySource = (item.deliverySource || '').trim().toLowerCase();
    const normalizedExtraLeadTime = this.toRoundedInteger(extraLeadTime ?? item.extraLeadTime ?? 0);

    if (deliverySource === 'itdcr') {
      return;
    }

    if (deliverySource === 'delegation' || deliverySource === 'manual') {
      const deliveryDates = Array.isArray(item.deliveryDatesCollection) ? item.deliveryDatesCollection : [];
      deliveryDates.forEach(dd => {
        const baseWeeks = this.toRoundedInteger(dd.deliveryNumberOfWeeks ?? 0);
        dd.deliveryNumberOfWeeksWithExtraLeadTime = baseWeeks + normalizedExtraLeadTime;
      });
      item.deliveryDatesCollection = deliveryDates;
      return;
    }

    if (deliverySource === 'none') {
      item.deliveryDatesCollection = [{
        deliveryNumberOfWeeks: 0,
        deliveryNumberOfWeeksWithExtraLeadTime: normalizedExtraLeadTime
      }];
    }
  }

  onInputDeliveryNotes($event: any, row: any) {
    if ($event.target.value == row['deliveryNotes']) {
      row.deliveryNotesEdited = row['deliveryNotes'] !== this.enquiryToEdit.items?.find(i => i.itemNo == row.itemNo)?.deliveryNotes;
      return;
    }

    row['deliveryNotes'] = $event.target.value;
    row.deliveryNotesEdited = true;
    row.priceEdited = true;
    this.updateGlobalPriceEdited();
  }

  onInpuFinalPrice($event: any, row: any) {

    $event.target.value = $event.target.value.toString().replaceAll(',', '.');

    if (isNaN($event.target.value))
      return;

    if (Number($event.target.value) == Number(row.finalPrice)) {
      return;
    }

    const value = $event.target.value == "" ? 0 : $event.target.value;
    const newFinalPrice = Number.parseFloat(value);
    // this.recalculateMargins(row, newFinalPrice, row.finalPrice);
    this.previousFinalPrice = Number(row.finalPrice);
    row.finalPrice = newFinalPrice;
    this.calculateItemMarginsAndPrices(row, 'FinalPrice');
    row.isFinalPriceManuallyChanged = true;
    row.isActualCmManuallyChanged = false;
    row.costUpdated = true;
    row.priceEdited = true;
    this.updateGlobalPriceEdited();

  }

  atLeastOneCostValid() {
    return this.enquiryToEdit && this.enquiryToEdit.items?.some(i => i['costsStatus'] == 'Validated');
  }

  reloadMyDataset(reload: boolean) {
    if (!reload) return;

    this.teiasoftLoader.start();
    this.backendService.editAndCreateVersionIfNecessary(this.enquiryToEdit.enquiryNo!).subscribe({
      next: res => {
        this.enquiryToEdit = new Enquiry();
        this.enquiryToEdit = res;
        this.dialogTitle = this.translate.instant("enquiryBook.editEnquiry") + " - " + this.enquiryToEdit.enquiryNo!;
        this.enquiryAttachments = new Array();
        this.enquiryAttachments = JSON.parse(JSON.stringify(this.enquiryToEdit.header!.enquiryAttachments!));
        this.fillDataSet();
        this.fillDataSetItems();
        this.reloadEnquiry.emit(this.enquiryToEdit.enquiryNo);
      },
      error: () => {
        this.teiasoftLoader.stop();
      },
      complete: () => this.teiasoftLoader.stop()
    });
  }

  formatDate(date: number) {
    return this.utils.formatDate(date);
  }

  formatWeekDate(dateMillis: number) {
    const date = new Date(dateMillis);
    if (isNaN(date.getTime())) return '';

    // Get full year and last two digits
    const fullYear = date.getFullYear();
    const yearSuffix = fullYear.toString().slice(-2);

    const firstJan = new Date(fullYear, 0, 1);
    const diffDays = Math.floor((date.getTime() - firstJan.getTime()) / (1000 * 60 * 60 * 24));
    const weekNumber = Math.ceil((diffDays + firstJan.getDay() + 1) / 7);

    return `W${weekNumber}-${yearSuffix}`;
  }

  getItemRowMinDeliveryDate(row: EnquiryHeaderItem): string {
    const item = this.enquiryToEdit.items?.find(i => i.itemNo === row.itemNo) as EnquiryHeaderItem;
    if (!item) return '';

    // If delivery source is ITDCR we use the earliest week-of-year (e.g. W01-25)
    if (item.deliverySource?.toLowerCase() === 'itdcr') {
      const minWeekOfYear = item.deliveryDatesCollection
        ?.map(dd => this.normalizeWeekOfYear(dd.deliveryWeekOfYear))
        .filter((week): week is string => !!week)
        .reduce<string | undefined>((min, current) => {
          if (!min) return current;
          return this.isWeekOfYearBefore(current, min) ? current : min;
        }, undefined);

      if (minWeekOfYear) return minWeekOfYear;
    }

    // Get minimum weeks value
    const minWeeks = item?.deliveryDatesCollection
      ?.map(dd => dd.deliveryNumberOfWeeksWithExtraLeadTime)
      .filter(weeks => typeof weeks === 'number' && weeks > 0)
      .reduce((min, current) => Math.min(min!, current!), Infinity);

    return minWeeks === Infinity ? '' : this.formatWeeks(minWeeks!);
  }

  private normalizeWeekOfYear(value?: string): string | undefined {
    if (!value) return undefined;

    const trimmed = value.trim();
    if (!trimmed) return undefined;

    if (/^W\d{2}-\d{2}$/.test(trimmed)) return trimmed;

    const isoMatch = /^(\d{4})-W(\d{1,2})$/.exec(trimmed);
    if (isoMatch) {
      const weekNumber = parseInt(isoMatch[2], 10);
      const year = isoMatch[1].slice(-2);
      const paddedWeek = weekNumber.toString().padStart(2, '0');
      return `W${paddedWeek}-${year}`;
    }

    const compactMatch = /^W?(\d{1,2})[-/](\d{2,4})$/.exec(trimmed);
    if (compactMatch) {
      const weekNumber = parseInt(compactMatch[1], 10);
      const yearPart = compactMatch[2];
      const year = yearPart.length === 4 ? yearPart.slice(-2) : yearPart;
      const paddedWeek = weekNumber.toString().padStart(2, '0');
      return `W${paddedWeek}-${year}`;
    }

    return undefined;
  }

  private weekOfYearToComparable(value?: string): number | null {
    const normalized = this.normalizeWeekOfYear(value);
    if (!normalized) return null;

    const match = /^W(\d{2})-(\d{2})$/.exec(normalized);
    if (!match) return null;

    const week = Number(match[1]);
    const year = Number(match[2]);

    if (isNaN(week) || isNaN(year)) return null;

    return year * 100 + week;
  }

  private isWeekOfYearBefore(current: string, compareTo: string): boolean {
    const currentValue = this.weekOfYearToComparable(current);
    const compareValue = this.weekOfYearToComparable(compareTo);

    if (currentValue === null) return false;
    if (compareValue === null) return true;

    return currentValue < compareValue;
  }

  formatWeeks(weeks: number): string {
    return `${weeks} week${weeks > 1 ? 's' : ''}`;
  }

  private canSaveItemsWithDeliveryWeeks(items: EnquiryHeaderItem[]): boolean {
    const invalidItems = items.filter(item => this.hasInvalidResultingDeliveryWeek(item));
    if (invalidItems.length === 0) {
      return true;
    }

    this.teiasoftToaster.show("error", this.translate.instant("enquiryBook.negativeDeliveryWeeksError"));
    return false;
  }

  private hasInvalidResultingDeliveryWeek(item?: EnquiryHeaderItem | null): boolean {
    if (!item) {
      return false;
    }

    const deliverySource = (item.deliverySource || '').trim().toLowerCase();
    if (deliverySource === 'itdcr') {
      return false;
    }

    const deliveryDates = Array.isArray(item.deliveryDatesCollection) ? item.deliveryDatesCollection : [];
    return deliveryDates.some(dd => Number(dd.deliveryNumberOfWeeksWithExtraLeadTime) < 1);
  }

  getItemRowDeliveryDatesCollection(row: EnquiryHeaderItem) {
    const item = this.enquiryToEdit.items?.find(i => i.itemNo == row.itemNo) as EnquiryHeaderItem;

    return item.deliveryDatesCollection || [];
  }

  incrementCustomerItemNo(currentNo: string): string {
    let num = parseInt(currentNo, 10) + 1;
    return num.toString().padStart(currentNo.length, '0');
  }


  setItemWtOdIdBYNps(item: EnquiryHeaderItem) {
    return new Promise<void>((resolve) => {
      if (item.npsSchedule) {
        this.backendService.getNpsAndSchedules().subscribe((res) => {
          const nps = res.npsSchedules?.find(n => n.npsScheduleId === item.npsSchedule?.npsScheduleId);
          if (nps) {
            if (this.enquiryToEdit.header?.unitSystem == 'Metric') {
              item.wt = nps.wtMetric;
              item.od = nps.odMetric;
            } else {
              item.wt = nps.wtImperial;
              item.od = nps.odImperial;
            }
          }
          resolve();
        });
      }
      else
        resolve();
    });

  }

  calculateNextCustomerItemNoForAI(items: EnquiryHeaderItem[], index: number): string {
    if (items.length === 0) {
      // No items exist, start from 001
      return '001';
    }

    let maxCustomerItemNo = 0;
    let maxCustomerItemNoRaw = '';

    for (const item of items) {
      const parsedCustomerItemNo = parseInt(item.customerItemNo!, 10);

      if (!isNaN(parsedCustomerItemNo)) {
        if (parsedCustomerItemNo > maxCustomerItemNo) {
          maxCustomerItemNo = parsedCustomerItemNo;
          maxCustomerItemNoRaw = item.customerItemNo!;
        }
      }
    }

    // Determine next number based on previous format
    const nextCustomerItemNo = (maxCustomerItemNo + 1).toString();
    const paddingLength = maxCustomerItemNoRaw.length || 3; // Default to 3-digit format

    return nextCustomerItemNo.padStart(paddingLength, '0');
  }


  async onItemAIUploadComplete(res: ItemsFromAI) {
    this.showUploadFromAI = false;
    this.teiasoftLoader.start();

    // create new items
    // set received values from AI forEach item
    // set default values for each item
    // push to the existing items list
    // show edit in place
    let newItems = new Array<EnquiryHeaderItem>();

    let simulatedItemsList = [...(this.enquiryToEdit.items ?? [])];     // Clone the existing items list for numbering reference


    const processItems = res.items?.map(async (aiItem, index) => {
      let _item: EnquiryHeaderItem = new EnquiryHeaderItem();

      _item.od = aiItem.od;
      _item.id = aiItem.id;
      _item.wt = aiItem.wt;
      _item.npsSchedule = aiItem.npsSchedule;
      _item.normGrades = aiItem.normGrades;
      _item.quantity = aiItem.quantity;
      _item.quantityUom = aiItem.quantityUom;
      _item.lengthType = aiItem.lengthType;
      _item.lengthMin = aiItem.minLength;
      _item.lengthMax = aiItem.maxLength;
      _item.remarks = aiItem.remarks;
      _item.sms = aiItem.sms;
      _item.marketingRoute = aiItem.sms.marketingRoute;
      _item.alloySurcharge = true;
      _item.testCondition = aiItem.testCondition;
      _item.isImportedFromAI = true;

      await this.setItemWtOdIdBYNps(_item);

      // Calculate next customer item number
      _item.customerItemNo = this.calculateNextCustomerItemNoForAI(simulatedItemsList, index);
      // Push to the simulated list to ensure correct sequential numbering
      simulatedItemsList.push(_item);

      // SET DEFAULT VALUES FOR ITEM
      await this.setDefaultValuesForNewItem(_item);

      newItems.push(_item);
    })

    if (processItems) {
      await Promise.all(processItems);
    }

    newItems = newItems
      .sort(
        (a, b) => {
          return Number(a.customerItemNo) - Number(b.customerItemNo); //  "itemNo"
        }
      );


    this.itemsToEdit = new Array();
    this.itemsToEdit = JSON.parse(JSON.stringify(this.enquiryToEdit.items!.concat(newItems)));
    this.itemsToEdit = this.itemsToEdit.map(this.sortItemProperties);
    // this.itemsToEdit = this.itemsToEdit.sort((a, b) => (a.customerItemNo! > b.customerItemNo!) ? 1 : ((b.customerItemNo! > a.customerItemNo!) ? -1 : 0))
    this.teiasoftLoader.stop();
    this.itemsFromXlsx = undefined;
    this.showEditInPlace = true;
  }

  async setDefaultValuesForNewItem(item: EnquiryHeaderItem, createFromHeader: boolean = false) {
    item.itemNo = null;
    item.alloySurcharge = true;
    item.energySurcharge = false;
    item.unitSystem = this.enquiryToEdit.header!.unitSystem ? this.enquiryToEdit.header!.unitSystem! : '';
    item.currency = this.enquiryToEdit.header!.currency ? this.enquiryToEdit.header!.currency! : '';

    if (createFromHeader) {
      item.sms = new ItemSms();
      item.sms = this.enquiryToEdit.header!.sms! ? this.enquiryToEdit.header!.sms! : null;
      item.marketingRoute = this.enquiryToEdit.header!.sms ? this.enquiryToEdit.header!.sms.marketingRoute : '';
    }

    item.marketFamily = new MarketFamily;
    item.marketFamily = this.enquiryToEdit.header!.marketFamily;
    // item.customerDeliveryDate = null;
    item.alloySurcharge = true;
    item.energySurcharge = false;
    item.applicableNorms = this.enquiryToEdit.header!.applicableNorms ? this.enquiryToEdit.header!.applicableNorms! : '';

    await this.calculateAndSetNormsAndGrades(item);

    if (!item.npsSchedule) {
      item.npsSchedule = new EnquiryNpsSchedule();
      item.npsSchedule = this.enquiryToEdit.header!.npsSchedule! ? this.enquiryToEdit.header!.npsSchedule! : null;
      await this.setItemWtOdIdBYNps(item);
    }

    item.od = createFromHeader ? this.enquiryToEdit.header!.od! : item.od;
    item.odUom = this.enquiryToEdit.header!.odUom ? this.enquiryToEdit.header!.odUom! : '';
    item.odTolerancePlus = null;
    item.odToleranceMinus = null;
    item.odToleranceUom = '';
    item.id = createFromHeader ? this.enquiryToEdit.header!.id! : item.id;
    item.idUom = this.enquiryToEdit.header!.idUom ? this.enquiryToEdit.header!.idUom! : '';
    item.idTolerancePlus = null;
    item.idToleranceMinus = null;
    item.idToleranceUom = '';
    item.wt = createFromHeader ? this.enquiryToEdit.header!.wt! : item.wt;
    item.wtUom = this.enquiryToEdit.header!.wtUom ? this.enquiryToEdit.header!.wtUom! : '';
    item.typeOfTolerance = item.wt ? this.itemParameterValues.typeOfTolerance!.find(tot => tot.isDefault)?.value : null;

    // wt tolerance are not more mandatory
    // item.tubeExecution = new TubeExecution();
    // item.tubeExecution = item.wt ? item.sms!.marketingRoute!.indexOf("Cold") != -1 ? this.itemParameterValues.tubeExecution!.filter(x => x.isDefaultForCold)[0] : this.itemParameterValues.tubeExecution!.filter(x => x.isDefaultForHot)[0] : null;
    item.tubeExecution = null;
    item.wtTolerancePlus = null;
    item.wtToleranceMinus = null;
    item.wtToleranceUom = '';
    // if (item.wt)
    //   this.setDefaultTolerances(item);
    // item.wtToleranceUom = item.wt ? '%' : '';

    item.lengthType = item.lengthType || 'RL';
    item.lengthMin = Number.isFinite(item.lengthMin) ? item.lengthMin : null;
    item.lengthMax = Number.isFinite(item.lengthMax) ? item.lengthMax : null;
    item.lengthUom = this.getDefaultItemLength(item.unitSystem);
    item.multipleLength = false;
    item.uBent = false;
    item.quantity = item.quantity || null;
    item.quantityUom = item.quantityUom || this.getDefaultItemQtyUom(item.unitSystem, item.sms?.description, item.lengthType);
    item.totalWeight = this.enquiryToEdit.header!.totalWeight!;
    item.totalWeightUom = this.enquiryToEdit.header!.totalWeightUom ? this.enquiryToEdit.header!.totalWeightUom : '';

    this.setDefaultMill(item);

    if (item.lengthMin == null && item.lengthMax == null)
      this.setDefaultLength(item);
    item.lengthNominal = item.lengthType == 'FL' ? item.lengthMin : null;


    this.setDefaultSurfaceType(item);

    item.endsCondition = this.itemParameterValues.endsCondition?.find(i => i.isDefault)?.value;;
    item.testCondition = this.enquiryToEdit.header?.orderReason == 'Stock' ? (item.testCondition || this.itemParameterValues.testCondition?.find(i => i.isDefault)?.value) : undefined;
    item.sql = item.sql || this.itemParameterValues.sqls?.find(i => i.isDefault);
    item.offerScheme = item.offerScheme || this.itemParameterValues.offerSchemes?.find(i => i.isDefault);
    item.ut = this.itemParameterValues.ut?.find(i => i.isDefault)?.value;
    item.hydroTest = this.itemParameterValues.hydroTest?.find(i => i.isDefault)?.value;
    item.ht = this.resolveDefaultHtValue(item);
    item.htAdditional = this.itemParameterValues.htAdditional?.find(i => i.isDefault)?.value;
    item.inspectionType3Dot2 = this.itemParameterValues.inspectionType3dot2?.find(i => i.isDefault)?.value;
    item.multipleCutting = this.itemParameterValues.multipleCutting?.find(i => i.isDefault)?.value;
    item.remarks = item.remarks || '';

    item.offerScheme = this.enquiryToEdit.header?.offerScheme;

  }

  private resolveDefaultHtValue(item: EnquiryHeaderItem): boolean {
    return item.sms?.marketingRoute == 'Cold';
  }

  private normalizeSurfaceText(value?: string | null): string {
    return (value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  private findSurfaceTypeByNames(names: string[]) {
    const candidates = names.map(name => this.normalizeSurfaceText(name));
    return this.itemParameterValues.surfaceTypes?.find(surface => {
      const surfaceName = this.normalizeSurfaceText(surface.name);
      const description = this.normalizeSurfaceText((surface as any).description);
      return candidates.includes(surfaceName) || candidates.includes(description);
    });
  }

  private getItemOdInMm(item: EnquiryHeaderItem): number | null {
    const od = Number(item.od);
    if (!Number.isFinite(od)) {
      return null;
    }

    const uom = (item.odUom || '').toString().toLowerCase();
    if (uom == 'in') return od * 25.4;
    if (uom == 'cm') return od * 10;
    if (uom == 'dm') return od * 100;
    if (uom == 'm') return od * 1000;
    return od;
  }

  private resolveDefaultSurfaceType(item: EnquiryHeaderItem) {
    const route = (item.sms?.marketingRoute || '').toString().toLowerCase();
    const pickled = this.findSurfaceTypeByNames(['PICKLED / PASSIVATED']);
    const freeFromScale = this.findSurfaceTypeByNames(['FREE FROM SCALE']);
    const brightAnnealed = this.findSurfaceTypeByNames(['BRIGHT ANNEALED', 'IN BRIGHT CONDITION']);

    if (route != 'cold') {
      return pickled;
    }

    const millShortName = (item.mill?.shortName || '').toString().toUpperCase();
    const odMm = this.getItemOdInMm(item);

    if (millShortName == 'CV' && odMm !== null && odMm >= 6 && odMm <= 15) {
      return brightAnnealed || pickled;
    }

    if (millShortName == 'CV' && odMm !== null && odMm > 15) {
      return freeFromScale || pickled;
    }

    if (millShortName == 'RS') {
      return freeFromScale || pickled;
    }

    return pickled;
  }

  setDefaultTolerances(item: EnquiryHeaderItem) {
    const isCustom = item.tubeExecution?.isCustom;

    if (!isCustom) {
      if (item.typeOfTolerance == 'AW') {
        item.wtToleranceMinus = item.tubeExecution!.toleranceMinusAw;
        item.wtTolerancePlus = item.tubeExecution!.tolerancePlusAw;
      }
      if (item.typeOfTolerance == 'MW') {
        item.wtToleranceMinus = item.tubeExecution!.toleranceMinusMw;
        item.wtTolerancePlus = item.tubeExecution!.tolerancePlusMw;
      }
    }
  }


  setDefaultMill(item: EnquiryHeaderItem) {
    item.mill = new Mill();

    let _data: Mill = new Mill();
    if (this.enquiryToEdit.header?.salesOffice == 'DUS' || this.enquiryToEdit.header?.salesOffice == 'EU1') {
      _data = this.itemParameterValues.mills!.find(x => x.shortName == 'HO')!;
    } else {
      if (item.sms!.marketingRoute == 'Hot')
        _data = this.itemParameterValues.mills!.find(x => x.shortName == 'MB')!;

      if (item.sms!.marketingRoute == 'Cold' && item.od! >= 6 && item.od! <= 88.99)
        _data = this.itemParameterValues.mills!.find(x => x.shortName == 'CV')!;

      if (item.sms!.marketingRoute == 'Cold' && item.od! > 88.99)
        _data = this.itemParameterValues.mills!.find(x => x.shortName == 'RS')!;
    }

    if (_data.millId) {
      item.mill = _data;
    }
    else {
      item.mill = undefined;
    }
  }

  setDefaultSurfaceType(item: EnquiryHeaderItem) {
    item.surfaceType = this.resolveDefaultSurfaceType(item);
  }


  setDefaultLength(item: EnquiryHeaderItem) {
    if (!item || !this.enquiryToEdit?.header?.unitSystem) return;

    const isMetric = this.enquiryToEdit.header.unitSystem === 'Metric';
    const odMinKey = isMetric ? 'odMinMetric' : 'odMinImperial';
    const odMaxKey = isMetric ? 'odMaxMetric' : 'odMaxImperial';
    const idMinKey = isMetric ? 'idMinMetric' : 'idMinImperial';
    const idMaxKey = isMetric ? 'idMaxMetric' : 'idMaxImperial';
    const wtMinKey = isMetric ? 'wtMinMetric' : 'wtMinImperial';
    const wtMaxKey = isMetric ? 'wtMaxMetric' : 'wtMaxImperial';
    const lengthMinKey = isMetric ? 'minLengthMetric' : 'minLengthImperial';
    const lengthMaxKey = isMetric ? 'maxLengthMetric' : 'maxLengthImperial';

    let odValue = Number(item.od);
    let idValue = Number(item.id);
    let wtValue = Number(item.wt);


    if (idValue) {
      if (!odValue) {
        odValue = idValue! - (2 * wtValue);
      }
      if (!wtValue) {
        wtValue = (odValue! - idValue!) / 2
      }
    }

    const defaultLengthList = this.itemParameterLengthValues.defaultLengths?.filter(dl => {
      return (
        (!dl.plantsId || dl.plantsId.includes(item.mill?.millId!)) &&
        (!dl.smsId || dl.smsId.includes(item.sms?.smsId!)) &&
        (!dl.rawMaterialGradesId || dl.rawMaterialGradesId.includes(item.rawMaterialGrade?.rawMaterialGradeId!)) &&
        (!dl.lengthType || dl.lengthType === item.lengthType) &&
        (!dl[odMinKey] || (odValue && odValue >= dl[odMinKey]!)) &&
        (!dl[odMaxKey] || (odValue && odValue <= dl[odMaxKey]!)) &&
        (!dl[idMinKey] || (idValue && idValue >= dl[idMinKey]!)) &&
        (!dl[idMaxKey] || (idValue && idValue <= dl[idMaxKey]!)) &&
        (!dl[wtMinKey] || (wtValue && wtValue >= dl[wtMinKey]!)) &&
        (!dl[wtMaxKey] || (wtValue && wtValue <= dl[wtMaxKey]!))
      );
    });

    if (defaultLengthList?.length) {
      const bestMatch = defaultLengthList.reduce((best, current) => {
        const bestNulls = [best.plantsId, best.smsId, best.rawMaterialGradesId, best.lengthType].filter(v => v == null).length;
        const currentNulls = [current.plantsId, current.smsId, current.rawMaterialGradesId, current.lengthType].filter(v => v == null).length;
        return currentNulls < bestNulls ? current : best;
      });

      item.lengthMin = bestMatch[lengthMinKey];
      item.lengthMax = bestMatch[lengthMaxKey];
    }
  }

  calculateAndSetNormsAndGrades(item: EnquiryHeaderItem) {
    return new Promise<void>((resolve) => {
      let normIds = new Array();
      if (item.normGrades && item.normGrades.length > 0) {
        normIds = item.normGrades.map(n => n.normGradeId);
      }
      else {
        normIds = this.enquiryToEdit.header!.normGrades ? this.enquiryToEdit.header!.normGrades.map(n => n.normGradeId) : [];
        item.normGrades = this.enquiryToEdit.header!.normGrades;
      }
      this.subscriptions.add(this.backendService.getLimitationsForNormGrades(normIds).subscribe(res => {
        this.setItemLimitations(res, item);
        this.setItemRawMaterialGrade(normIds, item).then((res) => { resolve(); });
      }
      ));
    });

  }

  setItemLimitations(res: LimitationsForNormGrades, item: EnquiryHeaderItem) {
    item.gradeCustomerAnalysisLimitation = new ItemLimitation();
    let _i: number = -1;
    if (res.gradeCustomerAnalysisLimitations!.length > 0) {
      _i = res.gradeCustomerAnalysisLimitations!.findIndex(x => x.isDefault == true);
      item.gradeCustomerAnalysisLimitation.limitation = _i != -1 ? res.gradeCustomerAnalysisLimitations!.filter(x => x.isDefault == true)[0].limitation! : res.gradeCustomerAnalysisLimitations![0].limitation!;
      item.gradeCustomerAnalysisLimitation.isCustom = false;
    } else {
      item.gradeCustomerAnalysisLimitation.limitation = undefined;
      item.gradeCustomerAnalysisLimitation.isCustom = true;
    }

    item.gradeCustomerOtherLimitation = new ItemLimitation();
    if (res.gradeCustomerOtherLimitations!.length > 0) {
      _i = res.gradeCustomerOtherLimitations!.findIndex(x => x.isDefault == true);
      item.gradeCustomerOtherLimitation.limitation = _i != -1 ? res.gradeCustomerOtherLimitations!.filter(x => x.isDefault == true)[0].limitation : res.gradeCustomerOtherLimitations![0].limitation!;
      item.gradeCustomerOtherLimitation.isCustom = false;
    } else {
      item.gradeCustomerOtherLimitation.limitation = undefined;
      item.gradeCustomerOtherLimitation.isCustom = true;
    }
  }

  setItemRawMaterialGrade(normIds: any[], item: EnquiryHeaderItem) {
    return new Promise<void>(resolve => {
      const ignoreLimitations = item.gradeCustomerAnalysisLimitation?.isCustom || item.gradeCustomerOtherLimitation?.isCustom;
      const analysisLimitation = ignoreLimitations ? null : item.gradeCustomerAnalysisLimitation!.limitation!;
      const otherLimitation = ignoreLimitations ? null : item.gradeCustomerOtherLimitation!.limitation!;
      this.rawMaterialGradeService.getRawMaterialGradesFromNormGradesAndLimitations(normIds, analysisLimitation, otherLimitation).subscribe(res => {
        item.rawMaterialGrade = new RawMaterialGrade();
        item.rawMaterialGrade = this.getSingleAutoSelectableRawMaterialGrade(res.rawMaterialGrades) || null;

        // if more rm are avaialable try to pick the one specified for the header
        if (res.rawMaterialGrades && res.rawMaterialGrades.length > 1) {
          const headerRawMaterial = res.rawMaterialGrades.find(rm => rm.rawMaterialGradeCode == this.enquiryToEdit.header?.rawMaterialGrade && rm.isDummy !== true);
          if (headerRawMaterial) {
            item.rawMaterialGrade = headerRawMaterial;
          }
        }

        resolve();
      });
    })
  }

  private getSingleAutoSelectableRawMaterialGrade(rawMaterialGrades?: RawMaterialGrade[] | null): RawMaterialGrade | undefined {
    const selectableGrades = (rawMaterialGrades || []).filter(rawMaterialGrade => rawMaterialGrade?.isDummy !== true);
    return selectableGrades.length === 1 ? selectableGrades[0] : undefined;
  }

  isAlloySurchargeWarning(value: any): boolean {
    return value !== null && value !== undefined && value !== '' && Number(value) === 0;
  }

  onCloseCostingTool() {
    this.showCostingToolModal = false;
    this.reloadEnquiry.emit(this.enquiryToEdit.enquiryNo);
  }

  onCloseItdcrViewer() {
    this.showItdcrViewerModal = false;
    this.itdcrViewerNo = '';
    this.itdcrViewerShowHistory = true;
  }

  updateGlobalPriceEdited() {
    this.priceEdited = this.dataSetItems.some(row => row.priceEdited);
  }

  onOpenItdcrClick($event: OpenItdcrEvent) {
    this.onOpenITDCR.emit($event);
  }

  onSaveSpecialeRequirements($event: CustomerSpecialRequirement[]) {
    if ($event) {
      this.enquiryToEdit.header!.customerSpecialRequirements = $event;
      this.showSpecialRequirements = false;
      this.updateSpecialRequirementsButtonText();
    }
  }

  loadCustomerSpecialRequirements() {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getEnquiryCustomerSpecialRequirements(this.enquiryToEdit.enquiryNo!).subscribe(res => {
      this.enquiryToEdit.header!.customerSpecialRequirements = res.customerSpecialRequirements || new Array();
      this.teiasoftLoader.stop();
      this.updateSpecialRequirementsButtonText();
    }))
  }
}
